import { a as attachCustomStylesByClassNames, j as jsxRuntimeExports, S as StyledPreloaderWrapper, L as LoadingState, B as ButtonLoadingOverlayStyled, b as StyledLoadingState, R as RelalativeWrapper, C as CenterPosition, c as LoadingText, d as StyledSpinner, T as TranslationProvider, e as commonStyles, u as useValidator, g as getErrorMessage, E as ErrorMessage, f as cardBillingNameValidationMessageByErrorType, h as cardBillingNameValidationOrder, i as cardBillingNameValidator, k as cardExpiryValidationMessageByErrorType, l as cardExpiryValidationOrder, m as cardExpiryValidator, n as getCardCvcValidator, o as cardCvcLengthRange, p as cardCvcValidationMessageByErrorType, q as cardCvcValidationOrder, r as SupportedCardBrand, s as CardIcon, t as cardNumberValidationMessageByErrorType, v as cardNumberValidationOrder, w as cardNumberValidator, x as useHandleDropdownClick, y as Column, z as Row } from "../useHandleDropdownClick-BQlwGso1.js";
import { D, A } from "../useHandleDropdownClick-BQlwGso1.js";
import { mergeConfigs, formatCardExpiry, formatCardCvc, trimSpaces, formatCardNumber, convertCardExpiryToString, getCardNumberEnding, getCardBrand } from "@mangopay/checkout-sdk-core";
import { CheckoutSdkEnvironment } from "@mangopay/checkout-sdk-core";
import { createContext, useContext, useMemo, Suspense, useCallback, useState, useRef, useEffect, useLayoutEffect, forwardRef, useImperativeHandle } from "react";
import styled, { ThemeProvider, css, keyframes } from "styled-components";
import { useTranslation } from "react-i18next";
import "i18next";
import "i18next-fetch-backend";
const i18nResources = {
  // en: {
  //   translation: en,
  // },
  // fr: {
  //   translation: fr,
  // },
};
const translationKeys = [
  "card-information.header.label",
  "card.number.placeholder",
  "card.number.aria-label",
  "card.number.errors.required",
  "card.number.errors.min-length",
  "card.number.errors.invalid-number",
  "card.save.label",
  "card.saved-cards.choose-card.label",
  "card.saved-cards.clear-card.label",
  "card.saved-cards.saved-card.aria-label",
  "card.billing-name.placeholder",
  "card.billing-name.aria-label",
  "card.billing-name.errors.required",
  "card.billing-name.errors.min-length",
  "card.expiry.placeholder",
  "card.expiry.aria-label",
  "card.expiry.errors.required",
  "card.expiry.errors.pattern",
  "card.expiry.errors.expired",
  "card.cvc.placeholder",
  "card.cvc.aria-label",
  "card.cvc.errors.required",
  "card.cvc.errors.min-length",
  "card.cvc.errors.max-length",
  "billing-address.same-as-shipping.label",
  "billing-address.country.placeholder",
  "billing-address.country.aria-label",
  "billing-address.country.errors.required",
  "billing-address.zip.placeholder",
  "billing-address.zip.aria-label",
  "billing-address.zip.errors.required",
  "billing-address.zip.errors.min-length",
  "pay-button.label",
  "pay-button.aria-label",
  "payment-methods.show-less.label",
  "payment-methods.show-more.label",
  "payment-methods.applepay.label",
  "payment-methods.applepay.aria-label",
  "payment-success-state.label",
  // error messages
  "error.invalid_cvc",
  "error.authorization_required",
  "error.contact_card_issuer",
  "error.unsupported_card",
  "error.insufficient_funds",
  "error.unsupported_currency",
  "error.card_rejected",
  "error.expired_card",
  "error.suspected_fraud",
  "error.general_decline",
  "error.incorrect_number",
  "error.incorrect_pin",
  "error.invalid_address",
  "error.invalid_card_or_account",
  "error.invalid_amount",
  "error.invalid_date",
  "error.lost_restricted_or_stolen_card",
  "error.blocked_list",
  "error.not_permitted",
  "error.offline_or_online_pin_required",
  "error.pin_retry_exceeded",
  "error.processing_error",
  "error.withdrawal_count_limit_exceeded",
  "error.unknown",
  "error.fraud",
  "error.three_d_secure",
  "error.custom_rule",
  "error.payment_cancelled",
  "error.payment_rejected",
  "error.internal_server_error",
  "error.institution_not_responding",
  "error.authorize.payment-already-authorized",
  "error.param_error"
];
var AmountOptions = /* @__PURE__ */ ((AmountOptions2) => {
  AmountOptions2["Currency"] = "currency";
  AmountOptions2["Value"] = "value";
  return AmountOptions2;
})(AmountOptions || {});
var SdkOptions = /* @__PURE__ */ ((SdkOptions2) => {
  SdkOptions2["ClientId"] = "clientId";
  SdkOptions2["ClientToken"] = "clientToken";
  SdkOptions2["ProfilingMerchantId"] = "profilingMerchantId";
  SdkOptions2["Environment"] = "environment";
  SdkOptions2["PaymentMethods"] = "paymentMethods";
  SdkOptions2["RespectPaymentMethodsOrder"] = "respectPaymentMethodsOrder";
  SdkOptions2["Amount"] = "amount";
  SdkOptions2["Branding"] = "branding";
  SdkOptions2["Locale"] = "locale";
  SdkOptions2["TenantId"] = "tenantId";
  return SdkOptions2;
})(SdkOptions || {});
var CurrencyCode = /* @__PURE__ */ ((CurrencyCode2) => {
  CurrencyCode2["AED"] = "AED";
  CurrencyCode2["AUD"] = "AUD";
  CurrencyCode2["CAD"] = "CAD";
  CurrencyCode2["CHF"] = "CHF";
  CurrencyCode2["DKK"] = "DKK";
  CurrencyCode2["EUR"] = "EUR";
  CurrencyCode2["GBP"] = "GBP";
  CurrencyCode2["HKD"] = "HKD";
  CurrencyCode2["JPY"] = "JPY";
  CurrencyCode2["NOK"] = "NOK";
  CurrencyCode2["PLN"] = "PLN";
  CurrencyCode2["SEK"] = "SEK";
  CurrencyCode2["USD"] = "USD";
  return CurrencyCode2;
})(CurrencyCode || {});
const currencyCodeWithSymbols = [{
  currency: "Albania Lek",
  code: "ALL",
  symbol: "Lek"
}, {
  currency: "Afghanistan Afghani",
  code: "AFN",
  symbol: "؋"
}, {
  currency: "Argentina Peso",
  code: "ARS",
  symbol: "$"
}, {
  currency: "Aruba Guilder",
  code: "AWG",
  symbol: "ƒ"
}, {
  currency: "Australia Dollar",
  code: "AUD",
  symbol: "$"
}, {
  currency: "Azerbaijan New Manat",
  code: "AZN",
  symbol: "ман"
}, {
  currency: "Bahamas Dollar",
  code: "BSD",
  symbol: "$"
}, {
  currency: "Barbados Dollar",
  code: "BBD",
  symbol: "$"
}, {
  currency: "Belarus Ruble",
  code: "BYR",
  symbol: "p."
}, {
  currency: "Belize Dollar",
  code: "BZD",
  symbol: "BZ$"
}, {
  currency: "Bermuda Dollar",
  code: "BMD",
  symbol: "$"
}, {
  currency: "Bolivia Boliviano",
  code: "BOB",
  symbol: "$b"
}, {
  currency: "Bosnia and Herzegovina Convertible Marka",
  code: "BAM",
  symbol: "KM"
}, {
  currency: "Botswana Pula",
  code: "BWP",
  symbol: "P"
}, {
  currency: "Bulgaria Lev",
  code: "BGN",
  symbol: "лв"
}, {
  currency: "Brazil Real",
  code: "BRL",
  symbol: "R$"
}, {
  currency: "Brunei Darussalam Dollar",
  code: "BND",
  symbol: "$"
}, {
  currency: "Cambodia Riel",
  code: "KHR",
  symbol: "៛"
}, {
  currency: "Canada Dollar",
  code: "CAD",
  symbol: "$"
}, {
  currency: "Cayman Islands Dollar",
  code: "KYD",
  symbol: "$"
}, {
  currency: "Chile Peso",
  code: "CLP",
  symbol: "$"
}, {
  currency: "China Yuan Renminbi",
  code: "CNY",
  symbol: "¥"
}, {
  currency: "Colombia Peso",
  code: "COP",
  symbol: "$"
}, {
  currency: "Costa Rica Colon",
  code: "CRC",
  symbol: "₡"
}, {
  currency: "Croatia Kuna",
  code: "HRK",
  symbol: "kn"
}, {
  currency: "Cuba Peso",
  code: "CUP",
  symbol: "₱"
}, {
  currency: "Czech Republic Koruna",
  code: "CZK",
  symbol: "Kč"
}, {
  currency: "Denmark Krone",
  code: "DKK",
  symbol: "kr"
}, {
  currency: "Dominican Republic Peso",
  code: "DOP",
  symbol: "RD$"
}, {
  currency: "East Caribbean Dollar",
  code: "XCD",
  symbol: "$"
}, {
  currency: "Egypt Pound",
  code: "EGP",
  symbol: "£"
}, {
  currency: "El Salvador Colon",
  code: "SVC",
  symbol: "$"
}, {
  currency: "Estonia Kroon",
  code: "EEK",
  symbol: "kr"
}, {
  currency: "Euro Member Countries",
  code: "EUR",
  symbol: "€"
}, {
  currency: "Falkland Islands (Malvinas) Pound",
  code: "FKP",
  symbol: "£"
}, {
  currency: "Fiji Dollar",
  code: "FJD",
  symbol: "$"
}, {
  currency: "Ghana Cedis",
  code: "GHC",
  symbol: "¢"
}, {
  currency: "Gibraltar Pound",
  code: "GIP",
  symbol: "£"
}, {
  currency: "Guatemala Quetzal",
  code: "GTQ",
  symbol: "Q"
}, {
  currency: "Guernsey Pound",
  code: "GGP",
  symbol: "£"
}, {
  currency: "Guyana Dollar",
  code: "GYD",
  symbol: "$"
}, {
  currency: "Honduras Lempira",
  code: "HNL",
  symbol: "L"
}, {
  currency: "Hong Kong Dollar",
  code: "HKD",
  symbol: "$"
}, {
  currency: "Hungary Forint",
  code: "HUF",
  symbol: "Ft"
}, {
  currency: "Iceland Krona",
  code: "ISK",
  symbol: "kr"
}, {
  currency: "India Rupee",
  code: "INR",
  symbol: ""
}, {
  currency: "Indonesia Rupiah",
  code: "IDR",
  symbol: "Rp"
}, {
  currency: "Iran Rial",
  code: "IRR",
  symbol: "﷼"
}, {
  currency: "Isle of Man Pound",
  code: "IMP",
  symbol: "£"
}, {
  currency: "Israel Shekel",
  code: "ILS",
  symbol: "₪"
}, {
  currency: "Jamaica Dollar",
  code: "JMD",
  symbol: "J$"
}, {
  currency: "Japan Yen",
  code: "JPY",
  symbol: "¥"
}, {
  currency: "Jersey Pound",
  code: "JEP",
  symbol: "£"
}, {
  currency: "Kazakhstan Tenge",
  code: "KZT",
  symbol: "лв"
}, {
  currency: "Korea (North) Won",
  code: "KPW",
  symbol: "₩"
}, {
  currency: "Korea (South) Won",
  code: "KRW",
  symbol: "₩"
}, {
  currency: "Kyrgyzstan Som",
  code: "KGS",
  symbol: "лв"
}, {
  currency: "Laos Kip",
  code: "LAK",
  symbol: "₭"
}, {
  currency: "Latvia Lat",
  code: "LVL",
  symbol: "Ls"
}, {
  currency: "Lebanon Pound",
  code: "LBP",
  symbol: "£"
}, {
  currency: "Liberia Dollar",
  code: "LRD",
  symbol: "$"
}, {
  currency: "Lithuania Litas",
  code: "LTL",
  symbol: "Lt"
}, {
  currency: "Macedonia Denar",
  code: "MKD",
  symbol: "ден"
}, {
  currency: "Malaysia Ringgit",
  code: "MYR",
  symbol: "RM"
}, {
  currency: "Mauritius Rupee",
  code: "MUR",
  symbol: "₨"
}, {
  currency: "Mexico Peso",
  code: "MXN",
  symbol: "$"
}, {
  currency: "Mongolia Tughrik",
  code: "MNT",
  symbol: "₮"
}, {
  currency: "Mozambique Metical",
  code: "MZN",
  symbol: "MT"
}, {
  currency: "Namibia Dollar",
  code: "NAD",
  symbol: "$"
}, {
  currency: "Nepal Rupee",
  code: "NPR",
  symbol: "₨"
}, {
  currency: "Netherlands Antilles Guilder",
  code: "ANG",
  symbol: "ƒ"
}, {
  currency: "New Zealand Dollar",
  code: "NZD",
  symbol: "$"
}, {
  currency: "Nicaragua Cordoba",
  code: "NIO",
  symbol: "C$"
}, {
  currency: "Nigeria Naira",
  code: "NGN",
  symbol: "₦"
}, {
  currency: "Korea (North) Won",
  code: "KPW",
  symbol: "₩"
}, {
  currency: "Norway Krone",
  code: "NOK",
  symbol: "kr"
}, {
  currency: "Oman Rial",
  code: "OMR",
  symbol: "﷼"
}, {
  currency: "Pakistan Rupee",
  code: "PKR",
  symbol: "₨"
}, {
  currency: "Panama Balboa",
  code: "PAB",
  symbol: "B/."
}, {
  currency: "Paraguay Guarani",
  code: "PYG",
  symbol: "Gs"
}, {
  currency: "Peru Nuevo Sol",
  code: "PEN",
  symbol: "S/."
}, {
  currency: "Philippines Peso",
  code: "PHP",
  symbol: "₱"
}, {
  currency: "Poland Zloty",
  code: "PLN",
  symbol: "zł"
}, {
  currency: "Qatar Riyal",
  code: "QAR",
  symbol: "﷼"
}, {
  currency: "Romania New Leu",
  code: "RON",
  symbol: "lei"
}, {
  currency: "Russia Ruble",
  code: "RUB",
  symbol: "руб"
}, {
  currency: "Saint Helena Pound",
  code: "SHP",
  symbol: "£"
}, {
  currency: "Saudi Arabia Riyal",
  code: "SAR",
  symbol: "﷼"
}, {
  currency: "Serbia Dinar",
  code: "RSD",
  symbol: "Дин."
}, {
  currency: "Seychelles Rupee",
  code: "SCR",
  symbol: "₨"
}, {
  currency: "Singapore Dollar",
  code: "SGD",
  symbol: "$"
}, {
  currency: "Solomon Islands Dollar",
  code: "SBD",
  symbol: "$"
}, {
  currency: "Somalia Shilling",
  code: "SOS",
  symbol: "S"
}, {
  currency: "South Africa Rand",
  code: "ZAR",
  symbol: "R"
}, {
  currency: "Korea (South) Won",
  code: "KRW",
  symbol: "₩"
}, {
  currency: "Sri Lanka Rupee",
  code: "LKR",
  symbol: "₨"
}, {
  currency: "Sweden Krona",
  code: "SEK",
  symbol: "kr"
}, {
  currency: "Switzerland Franc",
  code: "CHF",
  symbol: "CHF"
}, {
  currency: "Suriname Dollar",
  code: "SRD",
  symbol: "$"
}, {
  currency: "Syria Pound",
  code: "SYP",
  symbol: "£"
}, {
  currency: "Taiwan New Dollar",
  code: "TWD",
  symbol: "NT$"
}, {
  currency: "Thailand Baht",
  code: "THB",
  symbol: "฿"
}, {
  currency: "Trinidad and Tobago Dollar",
  code: "TTD",
  symbol: "TT$"
}, {
  currency: "Turkey Lira",
  code: "TRY",
  symbol: ""
}, {
  currency: "Turkey Lira",
  code: "TRL",
  symbol: "₤"
}, {
  currency: "Tuvalu Dollar",
  code: "TVD",
  symbol: "$"
}, {
  currency: "Ukraine Hryvna",
  code: "UAH",
  symbol: "₴"
}, {
  currency: "United Kingdom Pound",
  code: "GBP",
  symbol: "£"
}, {
  currency: "United States Dollar",
  code: "USD",
  symbol: "$"
}, {
  currency: "Uruguay Peso",
  code: "UYU",
  symbol: "$U"
}, {
  currency: "Uzbekistan Som",
  code: "UZS",
  symbol: "лв"
}, {
  currency: "Venezuela Bolivar",
  code: "VEF",
  symbol: "Bs"
}, {
  currency: "Viet Nam Dong",
  code: "VND",
  symbol: "₫"
}, {
  currency: "Yemen Rial",
  code: "YER",
  symbol: "﷼"
}, {
  currency: "Zimbabwe Dollar",
  code: "ZWD",
  symbol: "Z$"
}];
var CheckoutSdkType = /* @__PURE__ */ ((CheckoutSdkType2) => {
  CheckoutSdkType2["CardForm"] = "cardForm";
  CheckoutSdkType2["Checkout"] = "checkout";
  return CheckoutSdkType2;
})(CheckoutSdkType || {});
const defaultTheme = {
  fontFamily: void 0,
  fontSize: {
    primary: "14px",
    secondary: "12px"
  },
  borderType: "round",
  colors: {
    primary: "#000000",
    secondary: "#545A61",
    accent: void 0,
    accentContrast: void 0,
    border: "#E6E9EC",
    borderFocused: "#000000",
    error: "#EC0B43"
  },
  borderRadius: void 0,
  textColor: void 0,
  lineHeight: "48px",
  backgroundColor: void 0,
  variables: void 0,
  rules: {
    PayButton: void 0,
    ".PayButton": void 0,
    PayButton__Card: void 0,
    ".PayButton__Card": void 0,
    PayButton__ApplePay: void 0,
    ".PayButton__ApplePay": void 0,
    PayButton__GooglePay: void 0,
    ".PayButton__GooglePay": void 0,
    PayButton__LoadingState: void 0,
    ".PayButton__LoadingState": void 0,
    PayButton__LoadingState__Card: void 0,
    ".PayButton__LoadingState__Card": void 0,
    PayButton__LoadingState__ApplePay: void 0,
    ".PayButton__LoadingState__ApplePay": void 0,
    PayButton__LoadingState__GooglePay: void 0,
    ".PayButton__LoadingState__GooglePay": void 0,
    PaymentErrorContainer: void 0,
    ".PaymentErrorContainer": void 0,
    PaymentErrorContainer__Label: void 0,
    ".PaymentErrorContainer__Label": void 0,
    ErrorMessage: void 0,
    ".ErrorMessage": void 0,
    SuccessStateContainer: void 0,
    ".SuccessStateContainer": void 0,
    SuccessStateContainer__Content: void 0,
    ".SuccessStateContainer__Content": void 0,
    SuccessStateContainer__Content__Icon: void 0,
    ".SuccessStateContainer__Content__Icon": void 0,
    SuccessStateContainer__Content__Label: void 0,
    ".SuccessStateContainer__Content__Label": void 0,
    GridColumn: void 0,
    ".GridColumn": void 0,
    GridRow: void 0,
    ".GridRow": void 0,
    FieldContainer: void 0,
    ".FieldContainer": void 0,
    FieldContainer__CardNumber: void 0,
    ".FieldContainer__CardNumber": void 0,
    FieldContainer__BillingName: void 0,
    ".FieldContainer__BillingName": void 0,
    FieldContainer__CardExpiry: void 0,
    ".FieldContainer__CardExpiry": void 0,
    FieldContainer__CardCvc: void 0,
    ".FieldContainer__CardCvc": void 0,
    TextField: void 0,
    ".TextField": void 0,
    TextField__CardNumber: void 0,
    ".TextField__CardNumber": void 0,
    TextField__BillingName: void 0,
    ".TextField__BillingName": void 0,
    TextField__CardExpiry: void 0,
    ".TextField__CardExpiry": void 0,
    TextField__CardCvc: void 0,
    ".TextField__CardCvc": void 0,
    SelectField: void 0,
    ".SelectField": void 0,
    SelectField__Option: void 0,
    ".SelectField__Option": void 0,
    CheckboxFieldContainer: void 0,
    ".CheckboxFieldContainer": void 0,
    CheckboxFieldContainer__InputContainer: void 0,
    ".CheckboxFieldContainer__InputContainer": void 0,
    CheckboxFieldContainer__InputContainer__Icon: void 0,
    ".CheckboxFieldContainer__InputContainer__Icon": void 0,
    IconContainer: void 0,
    ".IconContainer": void 0,
    IconContainer__Front: void 0,
    ".IconContainer__Front": void 0,
    IconContainer__Front__Flipped: void 0,
    ".IconContainer__Front__Flipped": void 0,
    IconContainer__Back: void 0,
    ".IconContainer__Back": void 0,
    IconContainer__Back__Flipped: void 0,
    ".IconContainer__Back__Flipped": void 0,
    CardNumberContainer: void 0,
    ".CardNumberContainer": void 0,
    CardNumberIconContainer: void 0,
    ".CardNumberIconContainer": void 0,
    SavedCardsContainer: void 0,
    ".SavedCardsContainer": void 0,
    SavedCardsContainer__ClearButton: void 0,
    ".SavedCardsContainer__ClearButton": void 0,
    SavedCardsDropdown: void 0,
    ".SavedCardsDropdown": void 0,
    SavedCardsDropdown__Button: void 0,
    ".SavedCardsDropdown__Button": void 0,
    SavedCardsDropdown__List: void 0,
    ".SavedCardsDropdown__List": void 0,
    SavedCardsDropdown__ListItem: void 0,
    ".SavedCardsDropdown__ListItem": void 0,
    SavedCardsDropdown__ListItem__Divider: void 0,
    ".SavedCardsDropdown__ListItem__Divider": void 0,
    SavedCardsDropdown__ListItem__CardBrandIcon: void 0,
    ".SavedCardsDropdown__ListItem__CardBrandIcon": void 0,
    SavedCardsDropdown__ListItem__CardNumber: void 0,
    ".SavedCardsDropdown__ListItem__CardNumber": void 0,
    SavedCardsDropdown__ListItem__CardExpiry: void 0,
    ".SavedCardsDropdown__ListItem__CardExpiry": void 0,
    CheckoutContainer: void 0,
    ".CheckoutContainer": void 0,
    DividerContainer: void 0,
    ".DividerContainer": void 0,
    DividerContainer__Divider: void 0,
    ".DividerContainer__Divider": void 0,
    DividerContainer__Label: void 0,
    ".DividerContainer__Label": void 0,
    PaymentMethodContainer: void 0,
    ".PaymentMethodContainer": void 0,
    PaymentMethodContainer__Card: void 0,
    ".PaymentMethodContainer__Card": void 0,
    PaymentMethodContainer__ApplePay: void 0,
    ".PaymentMethodContainer__ApplePay": void 0,
    PaymentMethodContainer__GooglePay: void 0,
    ".PaymentMethodContainer__GooglePay": void 0,
    PaymentMethodContainer__Radio: void 0,
    ".PaymentMethodContainer__Radio": void 0,
    PaymentMethodContainer__Radio__Card: void 0,
    ".PaymentMethodContainer__Radio__Card": void 0,
    PaymentMethodContainer__Radio__ApplePay: void 0,
    ".PaymentMethodContainer__Radio__ApplePay": void 0,
    PaymentMethodContainer__Radio__GooglePay: void 0,
    ".PaymentMethodContainer__Radio__GooglePay": void 0,
    PaymentMethodContainer__Radio__Checked: void 0,
    ".PaymentMethodContainer__Radio__Checked": void 0,
    PaymentMethodContainer__Radio__Card__Checked: void 0,
    ".PaymentMethodContainer__Radio__Card__Checked": void 0,
    PaymentMethodContainer__Radio__ApplePay__Checked: void 0,
    ".PaymentMethodContainer__Radio__ApplePay__Checked": void 0,
    PaymentMethodContainer__Radio__GooglePay__Checked: void 0,
    ".PaymentMethodContainer__Radio__GooglePay__Checked": void 0,
    PaymentMethodContainer__IconContainer: void 0,
    ".PaymentMethodContainer__IconContainer": void 0,
    PaymentMethodContainer__IconContainer__Card: void 0,
    ".PaymentMethodContainer__IconContainer__Card": void 0,
    PaymentMethodContainer__IconContainer__ApplePay: void 0,
    ".PaymentMethodContainer__IconContainer__ApplePay": void 0,
    PaymentMethodContainer__IconContainer__GooglePay: void 0,
    ".PaymentMethodContainer__IconContainer__GooglePay": void 0,
    PaymentMethodContainer__Label: void 0,
    ".PaymentMethodContainer__Label": void 0,
    PaymentMethodContainer__Label__Card: void 0,
    ".PaymentMethodContainer__Label__Card": void 0,
    PaymentMethodContainer__Label__ApplePay: void 0,
    ".PaymentMethodContainer__Label__ApplePay": void 0,
    PaymentMethodContainer__Label__GooglePay: void 0,
    ".PaymentMethodContainer__Label__GooglePay": void 0,
    SupportedCardBrandContainer: void 0,
    ".SupportedCardBrandContainer": void 0,
    SupportedCardBrandContainer__Icon: void 0,
    ".SupportedCardBrandContainer__Icon": void 0,
    RedirectNoteContainer: void 0,
    ".RedirectNoteContainer": void 0,
    RedirectNoteContainer__Icon: void 0,
    ".RedirectNoteContainer__Icon": void 0,
    RedirectNoteContainer__Label: void 0,
    ".RedirectNoteContainer__Label": void 0,
    ShowMoreOrLessButton: void 0,
    ".ShowMoreOrLessButton": void 0
  }
};
const convertVariableObjectToStyleObject = (variables) => {
  if (!variables || typeof variables !== "object") return void 0;
  const keys = Object.keys(variables);
  const convertToStyleObject = keys.reduce((acc, current) => {
    const variableKey = `--${current}`;
    const variableValue = variables[current];
    if (typeof variableValue !== "string") return acc;
    return {
      ...acc,
      [variableKey]: variableValue
    };
  }, {});
  return convertToStyleObject;
};
const CheckoutContainerWrapper = styled.div.withConfig({
  displayName: "CheckoutContainerstyled__CheckoutContainerWrapper",
  componentId: "sc-160ksly-0"
})(["width:100%;", ";"], (props) => attachCustomStylesByClassNames(props));
const CheckoutContext = createContext({});
const CheckoutContextProvider = CheckoutContext.Provider;
const useCheckoutContext = () => useContext(CheckoutContext);
const PreloadingComponent = () => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPreloaderWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingState, {}) });
const ButtonLoadingOverlay = () => /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonLoadingOverlayStyled, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLoadingState, { size: "25px" }) });
const Spinner = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSpinner, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", {})
] });
const FullScreenLoader = ({
  isVisible = false
}) => {
  const {
    t
  } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RelalativeWrapper, { isVisible, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(CenterPosition, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingText, { children: t("loading.label") })
  ] }) });
};
const CheckoutContainer = ({
  theme,
  language,
  children,
  amount,
  currency
}) => {
  const currentTheme = useMemo(() => mergeConfigs(defaultTheme, theme), [theme]);
  const convertedVariables = useMemo(() => convertVariableObjectToStyleObject(currentTheme.variables), [currentTheme.variables]);
  const contextValue = useMemo(() => ({
    amount,
    currency
  }), [amount, currency]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingState, {}), children: /* @__PURE__ */ jsxRuntimeExports.jsx(TranslationProvider, { language, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: currentTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckoutContextProvider, { value: contextValue, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckoutContainerWrapper, { className: "CheckoutContainer", style: convertedVariables, children }) }) }) }) });
};
const textButtonStyles = css(["text-decoration:none;background-color:transparent;border:0;cursor:pointer;"]);
const buttonStyles = css(["cursor:pointer;border:none;background-color:", ";padding:", " ", ";border-radius:", ";border:", ";transition:all 0.3s ease-out;&:hover{border-color:", ";}&:disabled{cursor:default;opacity:0.7;&:hover{border:", ";}}"], (props) => props.theme.backgroundColor || commonStyles.inputs.background, commonStyles.gutters.secondary, commonStyles.gutters.primary, (props) => props.theme.borderRadius || (props.theme.borderType === "round" ? commonStyles.border.radius : "0"), (props) => `1px solid ${props.theme.colors.border}`, (props) => props.theme.colors.borderFocused, (props) => `1px solid ${props.theme.colors.border}`);
const PaymentMethodContainer = styled.div.withConfig({
  displayName: "PaymentMethodstyled__PaymentMethodContainer",
  componentId: "sc-ptjt01-0"
})(["", ";width:100%;margin-bottom:", ";padding-top:0;padding-bottom:0;box-sizing:border-box;transition:all 0.3s ease-out;&.PaymentMethodContainer__Active{border-color:", ";cursor:unset;}&.PaymentMethodContainer__Card .PayButton{margin-bottom:16px;}", ";"], buttonStyles, commonStyles.gutters.primary, (props) => props.theme.colors.primary, (props) => attachCustomStylesByClassNames(props));
const PaymentMethodContainerContent = styled.div.withConfig({
  displayName: "PaymentMethodstyled__PaymentMethodContainerContent",
  componentId: "sc-ptjt01-1"
})(["width:100%;display:flex;align-items:center;", ";"], (props) => attachCustomStylesByClassNames(props));
const PaymentMethodIconContainer = styled.span.withConfig({
  displayName: "PaymentMethodstyled__PaymentMethodIconContainer",
  componentId: "sc-ptjt01-2"
})(["display:flex;justify-content:center;align-items:center;", ";"], (props) => attachCustomStylesByClassNames(props));
const PaymentMethodLabel = styled.span.withConfig({
  displayName: "PaymentMethodstyled__PaymentMethodLabel",
  componentId: "sc-ptjt01-3"
})(["font-size:", ";color:", ";margin-left:8px;font-weight:", ";line-height:", ";", ";"], (props) => props.theme.fontSize.primary, (props) => props.theme.textColor || props.theme.colors.primary, commonStyles.fontWeight.bold, (props) => props.theme.lineHeight, (props) => attachCustomStylesByClassNames(props));
const PaymentMethodRadio = styled.div.withConfig({
  displayName: "PaymentMethodstyled__PaymentMethodRadio",
  componentId: "sc-ptjt01-4"
})(["width:16px;height:16px;border:2px solid ", ";border-radius:50%;display:block;position:relative;box-sizing:border-box;margin-right:8px;&::after{content:'';display:block;height:6px;width:6px;border-radius:50%;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background-color:rgba(0,0,0,0);}&.PaymentMethodContainer__Radio__Checked{background-color:", ";border-color:", ";&::after{background-color:#fff;}}", ";"], (props) => props.theme.colors.border, (props) => props.theme.colors.primary, (props) => props.theme.colors.primary, (props) => attachCustomStylesByClassNames(props));
const PaymentMethod = ({
  id,
  ariaLabel,
  label,
  icon,
  disabled,
  onSelect,
  type,
  activePaymentMethod,
  children
}) => {
  const isActive = activePaymentMethod === (type == null ? void 0 : type.toLowerCase());
  const handleClick = useCallback(() => {
    if (disabled || isActive) return;
    onSelect == null ? void 0 : onSelect();
  }, [onSelect, isActive]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PaymentMethodContainer, { id, "aria-label": ariaLabel, onClick: handleClick, className: `PaymentMethodContainer PaymentMethodContainer__${type} ${isActive ? `PaymentMethodContainer__Active PaymentMethodContainer__Active__${type}` : ""}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(PaymentMethodContainerContent, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(PaymentMethodRadio, { className: `PaymentMethodContainer__Radio PaymentMethodContainer__Radio__${type} ${isActive ? `PaymentMethodContainer__Radio__Checked PaymentMethodContainer__Radio__${type}__Checked` : ""}` }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PaymentMethodIconContainer, { className: `PaymentMethodContainer__IconContainer PaymentMethodContainer__IconContainer__${type}`, children: icon }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PaymentMethodLabel, { className: `PaymentMethodContainer__Label PaymentMethodContainer__Label__${type}`, children: label })
    ] }),
    isActive && children
  ] });
};
const CvcIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "34", height: "24", viewBox: "0 0 34 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "34", height: "24", rx: "4", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "0.25", y: "0.25", width: "33.5", height: "23.5", rx: "3.75", stroke: "black", strokeOpacity: "0.15", strokeWidth: "0.5" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { y: "5", width: "34", height: "4", fill: "#C1C3C6" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "3", y: "15", width: "6", height: "3", rx: "1.5", fill: "#C1C3C6" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "11", y: "15", width: "3", height: "3", rx: "1.5", fill: "#C1C3C6" })
] });
const CloseIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5893 4.41205C15.9148 4.73748 15.9148 5.26512 15.5893 5.59056L5.58934 15.5906C5.2639 15.916 4.73626 15.916 4.41083 15.5906C4.08539 15.2651 4.08539 14.7375 4.41083 14.412L14.4108 4.41205C14.7363 4.08661 15.2639 4.08661 15.5893 4.41205Z", fill: "#09030B" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.41083 4.41205C4.73626 4.08661 5.2639 4.08661 5.58934 4.41205L15.5893 14.412C15.9148 14.7375 15.9148 15.2651 15.5893 15.5906C15.2639 15.916 14.7363 15.916 14.4108 15.5906L4.41083 5.59056C4.08539 5.26512 4.08539 4.73748 4.41083 4.41205Z", fill: "#09030B" })
] });
const PaypalIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "34", height: "24", viewBox: "0 0 34 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "0.5", y: "0.5", width: "33", height: "23", rx: "3.5", fill: "white", stroke: "#E8E8E8" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.613 18.4483L14.8338 16.9992L14.3421 16.9873H11.9941L13.6259 6.2937C13.631 6.26132 13.6474 6.23126 13.6714 6.20987C13.6955 6.18849 13.7262 6.17676 13.7584 6.17676H17.7174C19.0318 6.17676 19.9388 6.45939 20.4123 7.01734C20.6343 7.27908 20.7757 7.55267 20.8442 7.85364C20.9159 8.16951 20.9171 8.54685 20.8471 9.00715L20.8421 9.04063V9.33561L21.0641 9.46563C21.251 9.56815 21.3996 9.68546 21.5136 9.81975C21.7034 10.0436 21.8263 10.3281 21.8782 10.6652C21.9318 11.012 21.9141 11.4248 21.8263 11.892C21.725 12.4295 21.5612 12.8976 21.34 13.2805C21.1367 13.6334 20.8775 13.9262 20.5698 14.153C20.276 14.3686 19.927 14.5322 19.5324 14.6369C19.1499 14.7398 18.7139 14.7917 18.2357 14.7917H17.9276C17.7073 14.7917 17.4933 14.8737 17.3254 15.0207C17.1569 15.1708 17.0455 15.3758 17.0113 15.6L16.9881 15.7305L16.598 18.2848L16.5804 18.3785C16.5757 18.4082 16.5677 18.423 16.5558 18.433C16.5453 18.4422 16.5302 18.4483 16.5154 18.4483H14.613Z", fill: "#28356A" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.2741 9.07471C21.2624 9.15279 21.2488 9.23258 21.2337 9.31458C20.7116 12.0852 18.9254 13.0424 16.6441 13.0424H15.4825C15.2035 13.0424 14.9684 13.2517 14.925 13.5362L14.1619 18.5394C14.1336 18.7263 14.2729 18.8945 14.4552 18.8945H16.5153C16.7592 18.8945 16.9665 18.7113 17.0049 18.4627L17.0251 18.3545L17.413 15.8103L17.438 15.6708C17.4759 15.4213 17.6836 15.238 17.9275 15.238H18.2356C20.2316 15.238 21.7942 14.4004 22.2509 11.9766C22.4416 10.9641 22.3429 10.1186 21.838 9.52402C21.6853 9.34476 21.4958 9.19592 21.2741 9.07471Z", fill: "#298FC2" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.7288 8.84944C20.649 8.82537 20.5667 8.80362 20.4823 8.78394C20.3974 8.76476 20.3105 8.74777 20.2211 8.73287C19.9079 8.68057 19.5647 8.65576 19.1971 8.65576H16.0941C16.0176 8.65576 15.945 8.6736 15.8801 8.70586C15.7369 8.77698 15.6306 8.91701 15.6049 9.08845L14.9447 13.41L14.9258 13.536C14.9692 13.2515 15.2043 13.0422 15.4833 13.0422H16.6449C18.9261 13.0422 20.7124 12.0845 21.2345 9.31439C21.2501 9.2324 21.2632 9.15261 21.2749 9.07452C21.1428 9.00206 20.9998 8.94011 20.8457 8.88732C20.8077 8.87425 20.7684 8.86166 20.7288 8.84944Z", fill: "#22284F" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6047 9.08862C15.6304 8.91718 15.7367 8.77715 15.8799 8.70652C15.9453 8.67414 16.0174 8.6563 16.0939 8.6563H19.1969C19.5645 8.6563 19.9077 8.68123 20.2208 8.73353C20.3103 8.74831 20.3972 8.76542 20.4821 8.7846C20.5665 8.80415 20.6488 8.82603 20.7286 8.84998C20.7682 8.8622 20.8075 8.8749 20.8459 8.88749C20.9999 8.94028 21.1431 9.00272 21.2752 9.07469C21.4305 8.05082 21.2739 7.3537 20.7383 6.72245C20.1478 6.0274 19.0821 5.72998 17.7184 5.72998H13.7593C13.4808 5.72998 13.2431 5.9393 13.2001 6.22426L11.5511 17.0279C11.5186 17.2416 11.6781 17.4344 11.8866 17.4344H14.3308L15.6047 9.08862Z", fill: "#28356A" })
] });
const ApplePayIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "34", height: "24", viewBox: "0 0 34 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "0.5", y: "0.5", width: "33", height: "23", rx: "3.5", fill: "white", stroke: "#E8E8E8" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.44921 8.34316C9.16382 8.69506 8.70721 8.97261 8.2506 8.93296C8.19353 8.45715 8.41707 7.95161 8.67867 7.63936C8.96406 7.27755 9.46348 7.01983 9.86777 7C9.91533 7.49563 9.72983 7.98135 9.44921 8.34316ZM9.86297 9.02712C9.46071 9.003 9.09366 9.15319 8.79718 9.2745C8.60639 9.35256 8.44483 9.41867 8.32191 9.41867C8.18397 9.41867 8.01574 9.34903 7.82685 9.27084L7.82685 9.27084C7.57935 9.16838 7.29638 9.05124 6.99964 9.05686C6.31948 9.06677 5.68688 9.46823 5.33967 10.1076C4.62621 11.3863 5.15417 13.2796 5.84384 14.3205C6.18155 14.8359 6.58584 15.4009 7.11855 15.3811C7.35291 15.3719 7.5215 15.2973 7.69597 15.2202C7.89683 15.1314 8.10549 15.0391 8.43131 15.0391C8.74582 15.0391 8.94536 15.129 9.1369 15.2152C9.31903 15.2973 9.49393 15.376 9.75358 15.3712C10.3053 15.3613 10.6525 14.8557 10.9902 14.3403C11.3547 13.7871 11.5148 13.2471 11.5391 13.1652L11.542 13.1557C11.5414 13.1551 11.5369 13.153 11.5289 13.1492C11.4071 13.0911 10.476 12.6469 10.467 11.4557C10.4581 10.4559 11.2056 9.94935 11.3233 9.86961L11.3233 9.8696C11.3304 9.86476 11.3353 9.86149 11.3374 9.85978C10.8618 9.12625 10.1198 9.04695 9.86297 9.02712ZM13.6824 15.3167V7.5898H16.4649C17.9013 7.5898 18.9049 8.62071 18.9049 10.1274C18.9049 11.6341 17.8822 12.675 16.4268 12.675H14.8334V15.3167H13.6824ZM14.8333 8.60088H16.1603C17.1592 8.60088 17.7299 9.15599 17.7299 10.1324C17.7299 11.1088 17.1592 11.6688 16.1556 11.6688H14.8333V8.60088ZM22.7053 14.3898C22.4009 14.9945 21.7302 15.3761 21.0072 15.3761C19.9371 15.3761 19.1903 14.712 19.1903 13.7108C19.1903 12.7196 19.9133 12.1496 21.2498 12.0653L22.6862 11.9761V11.5499C22.6862 10.9204 22.2915 10.5784 21.5875 10.5784C21.0072 10.5784 20.5839 10.8907 20.4983 11.3665H19.4614C19.4947 10.3653 20.3984 9.63675 21.6208 9.63675C22.9383 9.63675 23.7945 10.3554 23.7945 11.4706V15.3167H22.729V14.3898H22.7053ZM21.3163 14.4592C20.7027 14.4592 20.3127 14.1519 20.3127 13.6811C20.3127 13.1954 20.6885 12.9129 21.4067 12.8683L22.6861 12.784V13.2202C22.6861 13.9438 22.0964 14.4592 21.3163 14.4592ZM27.3284 15.619C26.867 16.9721 26.3391 17.4181 25.2166 17.4181C25.131 17.4181 24.8456 17.4082 24.779 17.3884V16.4616C24.8503 16.4715 25.0263 16.4814 25.1167 16.4814C25.6256 16.4814 25.911 16.2584 26.087 15.6785L26.1916 15.3365L24.2415 9.7111H25.4449L26.8004 14.2759H26.8242L28.1798 9.7111H29.3499L27.3284 15.619Z", fill: "black" })
] });
const SuccessCheckIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "28", height: "18", viewBox: "0 0 28 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M1 7.66667L11.6667 17L26.3333 1", stroke: "#787F88", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "check-path" }) });
const LockIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "21", height: "20", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.66602 9.99967C4.20578 9.99967 3.83268 10.3728 3.83268 10.833V16.6663C3.83268 17.1266 4.20578 17.4997 4.66602 17.4997H16.3327C16.7929 17.4997 17.166 17.1266 17.166 16.6663V10.833C17.166 10.3728 16.7929 9.99967 16.3327 9.99967H4.66602ZM2.16602 10.833C2.16602 9.4523 3.2853 8.33301 4.66602 8.33301H16.3327C17.7134 8.33301 18.8327 9.4523 18.8327 10.833V16.6663C18.8327 18.0471 17.7134 19.1663 16.3327 19.1663H4.66602C3.2853 19.1663 2.16602 18.0471 2.16602 16.6663V10.833Z", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 2.49967C9.61594 2.49967 8.7681 2.85086 8.14298 3.47599C7.51786 4.10111 7.16667 4.94895 7.16667 5.83301V9.16634C7.16667 9.62658 6.79357 9.99967 6.33333 9.99967C5.8731 9.99967 5.5 9.62658 5.5 9.16634V5.83301C5.5 4.50693 6.02678 3.23516 6.96447 2.29747C7.90215 1.35979 9.17392 0.833008 10.5 0.833008C11.8261 0.833008 13.0979 1.35979 14.0355 2.29747C14.9732 3.23516 15.5 4.50693 15.5 5.83301V9.16634C15.5 9.62658 15.1269 9.99967 14.6667 9.99967C14.2064 9.99967 13.8333 9.62658 13.8333 9.16634V5.83301C13.8333 4.94895 13.4821 4.10111 12.857 3.47599C12.2319 2.85086 11.3841 2.49967 10.5 2.49967Z", fill: "white" })
] });
const ChevronDown = () => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "12", height: "8", viewBox: "0 0 12 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.410093 0.91107C0.73553 0.585633 1.26317 0.585633 1.5886 0.91107L5.99935 5.32181L10.4101 0.91107C10.7355 0.585633 11.2632 0.585633 11.5886 0.91107C11.914 1.23651 11.914 1.76414 11.5886 2.08958L6.5886 7.08958C6.26317 7.41502 5.73553 7.41502 5.41009 7.08958L0.410093 2.08958C0.0846564 1.76414 0.0846564 1.23651 0.410093 0.91107Z", fill: "#333333" }) });
const InfoIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "InfoIcon", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.99935 1.99984C4.68564 1.99984 1.99935 4.68613 1.99935 7.99984C1.99935 11.3135 4.68564 13.9998 7.99935 13.9998C11.3131 13.9998 13.9993 11.3135 13.9993 7.99984C13.9993 4.68613 11.3131 1.99984 7.99935 1.99984ZM0.666016 7.99984C0.666016 3.94975 3.94926 0.666504 7.99935 0.666504C12.0494 0.666504 15.3327 3.94975 15.3327 7.99984C15.3327 12.0499 12.0494 15.3332 7.99935 15.3332C3.94926 15.3332 0.666016 12.0499 0.666016 7.99984Z", fill: "#595959" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.00065 7.3335C8.36884 7.3335 8.66732 7.63197 8.66732 8.00016V10.6668C8.66732 11.035 8.36884 11.3335 8.00065 11.3335C7.63246 11.3335 7.33398 11.035 7.33398 10.6668V8.00016C7.33398 7.63197 7.63246 7.3335 8.00065 7.3335Z", fill: "#595959" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.33398 5.33317C7.33398 4.96498 7.63246 4.6665 8.00065 4.6665H8.00732C8.37551 4.6665 8.67398 4.96498 8.67398 5.33317C8.67398 5.70136 8.37551 5.99984 8.00732 5.99984H8.00065C7.63246 5.99984 7.33398 5.70136 7.33398 5.33317Z", fill: "#595959" })
] });
const GooglePayIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "34", height: "24", viewBox: "0 0 753 400", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M552.7 0H200.7C90.7002 0 0.700195 90 0.700195 200C0.700195 310 90.7002 400 200.7 400H552.7C662.7 400 752.7 310 752.7 200C752.7 90 662.7 0 552.7 0Z", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M552.7 16.2C577.4 16.2 601.4 21.1 624 30.7C645.9 40 665.5 53.3 682.5 70.2C699.4 87.1 712.7 106.8 722 128.7C731.6 151.3 736.5 175.3 736.5 200C736.5 224.7 731.6 248.7 722 271.3C712.7 293.2 699.4 312.8 682.5 329.8C665.6 346.7 645.9 360 624 369.3C601.4 378.9 577.4 383.8 552.7 383.8H200.7C176 383.8 152 378.9 129.4 369.3C107.5 360 87.9002 346.7 70.9002 329.8C54.0002 312.9 40.7002 293.2 31.4002 271.3C21.8002 248.7 16.9002 224.7 16.9002 200C16.9002 175.3 21.8002 151.3 31.4002 128.7C40.7002 106.8 54.0002 87.2 70.9002 70.2C87.8002 53.3 107.5 40 129.4 30.7C152 21.1 176 16.2 200.7 16.2H552.7ZM552.7 0H200.7C90.7002 0 0.700195 90 0.700195 200C0.700195 310 90.7002 400 200.7 400H552.7C662.7 400 752.7 310 752.7 200C752.7 90 662.7 0 552.7 0Z", fill: "#3C4043" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M359.301 214.2V274.7H340.101V125.3H391.001C403.901 125.3 414.901 129.6 423.901 138.2C433.101 146.8 437.701 157.3 437.701 169.7C437.701 182.4 433.101 192.9 423.901 201.4C415.001 209.9 404.001 214.1 391.001 214.1H359.301V214.2ZM359.301 143.7V195.8H391.401C399.001 195.8 405.401 193.2 410.401 188.1C415.501 183 418.101 176.8 418.101 169.8C418.101 162.9 415.501 156.8 410.401 151.7C405.401 146.4 399.101 143.8 391.401 143.8H359.301V143.7Z", fill: "#3C4043" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M487.901 169.1C502.101 169.1 513.301 172.9 521.501 180.5C529.701 188.1 533.801 198.5 533.801 211.7V274.7H515.501V260.5H514.701C506.801 272.2 496.201 278 483.001 278C471.701 278 462.301 274.7 454.701 268C447.101 261.3 443.301 253 443.301 243C443.301 232.4 447.301 224 455.301 217.8C463.301 211.5 474.001 208.4 487.301 208.4C498.701 208.4 508.101 210.5 515.401 214.7V210.3C515.401 203.6 512.801 198 507.501 193.3C502.201 188.6 496.001 186.3 488.901 186.3C478.201 186.3 469.701 190.8 463.501 199.9L446.601 189.3C455.901 175.8 469.701 169.1 487.901 169.1ZM463.101 243.3C463.101 248.3 465.201 252.5 469.501 255.8C473.701 259.1 478.701 260.8 484.401 260.8C492.501 260.8 499.701 257.8 506.001 251.8C512.301 245.8 515.501 238.8 515.501 230.7C509.501 226 501.201 223.6 490.501 223.6C482.701 223.6 476.201 225.5 471.001 229.2C465.701 233.1 463.101 237.8 463.101 243.3Z", fill: "#3C4043" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M638.201 172.4L574.201 319.6H554.401L578.201 268.1L536.001 172.4H556.901L587.301 245.8H587.701L617.301 172.4H638.201Z", fill: "#3C4043" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M282.931 202C282.931 195.74 282.371 189.75 281.331 183.99H200.851V216.99L247.201 217C245.321 227.98 239.271 237.34 230.001 243.58V264.99H257.591C273.701 250.08 282.931 228.04 282.931 202Z", fill: "#4285F4" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M230.011 243.58C222.331 248.76 212.441 251.79 200.871 251.79C178.521 251.79 159.561 236.73 152.771 216.43H124.311V238.51C138.411 266.49 167.391 285.69 200.871 285.69C224.011 285.69 243.451 278.08 257.601 264.98L230.011 243.58Z", fill: "#34A853" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M150.09 200.05C150.09 194.35 151.04 188.84 152.77 183.66V161.58H124.31C118.48 173.15 115.2 186.21 115.2 200.05C115.2 213.89 118.49 226.95 124.31 238.52L152.77 216.44C151.04 211.26 150.09 205.75 150.09 200.05Z", fill: "#FABB05" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M200.871 148.3C213.501 148.3 224.811 152.65 233.741 161.15L258.191 136.72C243.341 122.89 223.981 114.4 200.871 114.4C167.401 114.4 138.411 133.6 124.311 161.58L152.771 183.66C159.561 163.36 178.521 148.3 200.871 148.3Z", fill: "#E94235" })
] });
const ApplePayPayButtonIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "49", height: "20", viewBox: "0 0 49 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M8.90022 2.5785C8.32934 3.25404 7.41592 3.78687 6.50251 3.71075C6.38833 2.79734 6.83552 1.82683 7.35883 1.2274C7.92972 0.532826 8.92877 0.038059 9.73752 0C9.83267 0.951475 9.46159 1.88392 8.90022 2.5785ZM9.72801 3.89153C8.40546 3.81541 7.2732 4.6432 6.64523 4.6432C6.00774 4.6432 5.04675 3.92959 4.00013 3.94862C2.63952 3.96765 1.37406 4.73834 0.679481 5.96575C-0.747731 8.42055 0.308406 12.0552 1.68804 14.0533C2.36359 15.0428 3.17234 16.1275 4.238 16.0894C5.24656 16.0514 5.64618 15.4329 6.86407 15.4329C8.09147 15.4329 8.44352 16.0894 9.50917 16.0704C10.6129 16.0514 11.3075 15.0809 11.983 14.0913C12.7537 12.9686 13.0677 11.8744 13.0867 11.8173C13.0677 11.7983 10.9554 10.9895 10.9364 8.55376C10.9173 6.5176 12.6015 5.5471 12.6776 5.49001C11.7261 4.08183 10.2418 3.92959 9.72801 3.89153ZM17.3684 1.13225V15.9657H19.6709V10.8944H22.8584C25.7699 10.8944 27.8155 8.89629 27.8155 6.00381C27.8155 3.11132 25.8079 1.13225 22.9345 1.13225H17.3684ZM19.6709 3.07326H22.3255C24.3236 3.07326 25.4654 4.13892 25.4654 6.01332C25.4654 7.88773 24.3236 8.96289 22.316 8.96289H19.6709V3.07326ZM32.0211 16.0799C33.4673 16.0799 34.8089 15.3473 35.4178 14.1865H35.4654V15.9657H37.5967V8.5823C37.5967 6.44148 35.884 5.06185 33.2485 5.06185C30.8032 5.06185 28.9954 6.46051 28.9288 8.38249H31.003C31.1742 7.46908 32.0211 6.86965 33.1819 6.86965C34.59 6.86965 35.3798 7.52617 35.3798 8.73454V9.55281L32.5063 9.72407C29.8327 9.88582 28.3864 10.98 28.3864 12.883C28.3864 14.8049 29.8802 16.0799 32.0211 16.0799ZM32.6395 14.3197C31.4121 14.3197 30.6319 13.7298 30.6319 12.8259C30.6319 11.8934 31.3836 11.3511 32.8203 11.2655L35.3798 11.1037V11.941C35.3798 13.3302 34.1999 14.3197 32.6395 14.3197ZM40.4416 20C42.6871 20 43.7432 19.1437 44.6662 16.5461L48.7099 5.20457H46.3693L43.6576 13.9677H43.61L40.8983 5.20457H38.4911L42.3921 16.0038L42.1828 16.6603C41.8308 17.7736 41.2599 18.2017 40.2418 18.2017C40.061 18.2017 39.709 18.1827 39.5663 18.1637V19.9429C39.6995 19.981 40.2703 20 40.4416 20Z", fill: "white" }) });
const TrashBinIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.3335 4.0026C1.3335 3.63441 1.63197 3.33594 2.00016 3.33594H14.0002C14.3684 3.33594 14.6668 3.63441 14.6668 4.0026C14.6668 4.37079 14.3684 4.66927 14.0002 4.66927H2.00016C1.63197 4.66927 1.3335 4.37079 1.3335 4.0026Z", fill: "#2D0F37" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.6665 1.9974C6.48969 1.9974 6.32012 2.06763 6.1951 2.19266C6.07007 2.31768 5.99984 2.48725 5.99984 2.66406V3.9974C5.99984 4.36559 5.70136 4.66406 5.33317 4.66406C4.96498 4.66406 4.6665 4.36559 4.6665 3.9974V2.66406C4.6665 2.13363 4.87722 1.62492 5.25229 1.24985C5.62736 0.874776 6.13607 0.664062 6.6665 0.664062H9.33317C9.8636 0.664062 10.3723 0.874776 10.7474 1.24985C11.1225 1.62492 11.3332 2.13363 11.3332 2.66406V3.9974C11.3332 4.36559 11.0347 4.66406 10.6665 4.66406C10.2983 4.66406 9.99984 4.36559 9.99984 3.9974V2.66406C9.99984 2.48725 9.9296 2.31768 9.80457 2.19266C9.67955 2.06763 9.50998 1.9974 9.33317 1.9974H6.6665ZM3.33317 3.33073C3.70136 3.33073 3.99984 3.62921 3.99984 3.9974V13.3307C3.99984 13.5075 4.07007 13.6771 4.1951 13.8021C4.32012 13.9272 4.48969 13.9974 4.6665 13.9974H11.3332C11.51 13.9974 11.6795 13.9272 11.8046 13.8021C11.9296 13.6771 11.9998 13.5075 11.9998 13.3307V3.9974C11.9998 3.62921 12.2983 3.33073 12.6665 3.33073C13.0347 3.33073 13.3332 3.62921 13.3332 3.9974V13.3307C13.3332 13.8612 13.1225 14.3699 12.7474 14.7449C12.3723 15.12 11.8636 15.3307 11.3332 15.3307H4.6665C4.13607 15.3307 3.62736 15.12 3.25229 14.7449C2.87722 14.3699 2.6665 13.8612 2.6665 13.3307V3.9974C2.6665 3.62921 2.96498 3.33073 3.33317 3.33073Z", fill: "#09030B" })
] });
const AlertIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_2844_8443)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9Z", fill: "#993939" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 5.25C9.41421 5.25 9.75 5.58579 9.75 6V9C9.75 9.41421 9.41421 9.75 9 9.75C8.58579 9.75 8.25 9.41421 8.25 9V6C8.25 5.58579 8.58579 5.25 9 5.25Z", fill: "#993939" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.25 12C8.25 11.5858 8.58579 11.25 9 11.25H9.0075C9.42171 11.25 9.7575 11.5858 9.7575 12C9.7575 12.4142 9.42171 12.75 9.0075 12.75H9C8.58579 12.75 8.25 12.4142 8.25 12Z", fill: "#993939" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_2844_8443", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "18", height: "18", fill: "white" }) }) })
] });
const StyledRedirectNoteWrapper = styled.div.withConfig({
  displayName: "RedirectNotestyled__StyledRedirectNoteWrapper",
  componentId: "sc-p4fxvr-0"
})(["width:100%;display:flex;align-items:flex-start;", ";"], (props) => attachCustomStylesByClassNames(props));
const StyledRedirectNoteLabel = styled.p.withConfig({
  displayName: "RedirectNotestyled__StyledRedirectNoteLabel",
  componentId: "sc-p4fxvr-1"
})(["font-family:", ";color:", ";font-size:14px;padding-bottom:12px;", ";"], (props) => props.theme.fontFamily, (props) => props.theme.textColor || props.theme.colors.secondary, (props) => attachCustomStylesByClassNames(props));
const StyledRedirectNoteIcon = styled.div.withConfig({
  displayName: "RedirectNotestyled__StyledRedirectNoteIcon",
  componentId: "sc-p4fxvr-2"
})(["margin-block-start:1em;margin-right:8px;", ";"], (props) => attachCustomStylesByClassNames(props));
const RedirectNote = ({
  label
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRedirectNoteWrapper, { className: "RedirectNoteContainer", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(StyledRedirectNoteIcon, { className: "RedirectNoteContainer__Icon", children: /* @__PURE__ */ jsxRuntimeExports.jsx(InfoIcon, {}) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(StyledRedirectNoteLabel, { className: "RedirectNoteContainer__Label", children: label })
] });
const TYPE$2 = "Apple_Pay";
const ApplePayPaymentMethod = ({
  disabled,
  onSelect,
  activePaymentMethod
}) => {
  const {
    t
  } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PaymentMethod, { id: "payWithApplePay", ariaLabel: t("payment-methods.applepay.aria-label"), icon: /* @__PURE__ */ jsxRuntimeExports.jsx(ApplePayIcon, {}), label: t("payment-methods.applepay.label"), disabled, onSelect, type: TYPE$2, activePaymentMethod, children: /* @__PURE__ */ jsxRuntimeExports.jsx(RedirectNote, { label: t("redirect-note.label") }) });
};
const TYPE$1 = "Google_Pay";
const GooglePayPaymentMethod = ({
  disabled,
  onSelect,
  activePaymentMethod
}) => {
  const {
    t
  } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PaymentMethod, { id: "payWithGooglePay", ariaLabel: t("payment-methods.googlepay.aria-label"), icon: /* @__PURE__ */ jsxRuntimeExports.jsx(GooglePayIcon, {}), label: t("payment-methods.googlepay.label"), disabled, onSelect, type: TYPE$1, activePaymentMethod, children: /* @__PURE__ */ jsxRuntimeExports.jsx(RedirectNote, { label: t("redirect-note.label") }) });
};
const ShowMoreOrLessButton = styled.button.withConfig({
  displayName: "ShowMoreOrLessstyled__ShowMoreOrLessButton",
  componentId: "sc-12aqrby-0"
})(["cursor:pointer;box-sizing:border-box;border:none;width:100%;height:40px;border-radius:", ";padding:8px;background-color:#f4f4f4;transition:all 0.3s ease-out;& svg{margin-left:12px;transition:all 0.2s ease;transform:", ";}", ";"], (props) => props.theme.borderRadius || (props.theme.borderType === "round" ? commonStyles.border.radius : "0"), (props) => props.$showMore ? "none" : "rotate(180deg)", (props) => attachCustomStylesByClassNames(props));
const ShowMoreOrLess = ({
  showMore,
  onClick
}) => {
  const {
    t
  } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ShowMoreOrLessButton, { onClick, $showMore: showMore, className: "ShowMoreOrLessButton", children: [
    showMore ? t("payment-methods.show-more.label") : t("payment-methods.show-less.label"),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronDown, {})
  ] });
};
const Label = styled.label.withConfig({
  displayName: "SaveCheckboxstyled__Label",
  componentId: "sc-1m0jnft-0"
})(["display:inline-flex;align-items:center;font-size:14px;color:", ";cursor:pointer;"], ({
  disabled
}) => disabled ? "#b0b0b0" : "#7c8184");
const SaveCheckboxWrapper = styled.div.withConfig({
  displayName: "SaveCheckboxstyled__SaveCheckboxWrapper",
  componentId: "sc-1m0jnft-1"
})(["margin-bottom:24px;"]);
const HiddenCheckbox = styled.input.attrs({
  type: "checkbox"
}).withConfig({
  displayName: "SaveCheckboxstyled__HiddenCheckbox",
  componentId: "sc-1m0jnft-2"
})(["border:0;clip:rect(0 0 0 0);clip-path:inset(50%);height:1px;width:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;&:disabled{cursor:not-allowed;}"]);
const StyledCheckbox = styled.div.withConfig({
  displayName: "SaveCheckboxstyled__StyledCheckbox",
  componentId: "sc-1m0jnft-3"
})(["width:16px;height:16px;border:1px solid ", ";border-radius:4px;margin-right:8px;position:relative;transition:all 0.2s ease;background-color:", ";pointer-events:", ";", ":checked + &{background-color:#000;border-color:#000;}", ":checked + &::after{content:'';position:absolute;left:5px;top:2px;width:4px;height:8px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg);}"], ({
  disabled
}) => disabled ? "#d3d3d3" : "#bdbcbe", ({
  disabled
}) => disabled ? "#f0f0f0" : "transparent", ({
  disabled
}) => disabled ? "none" : "auto", HiddenCheckbox, HiddenCheckbox);
const SaveCheckbox = ({
  label,
  value,
  onChange,
  disabled,
  testId = "save-checkbox",
  id
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Label, { "data-testid": testId, disabled, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(HiddenCheckbox, { id, disabled, checked: value, onChange }, String(disabled)),
  /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCheckbox, { disabled }),
  label
] });
const StyledPaypalCheckboxWrapper = styled.div.withConfig({
  displayName: "PaypalPaymentMethodstyled__StyledPaypalCheckboxWrapper",
  componentId: "sc-15jz7ps-0"
})(["width:100%;display:flex;align-items:flex-start;margin-top:12px;", ";label{font-family:", ";color:", ";font-size:14px;cursor:pointer;}span{width:16px;height:16px;}.InfoIcon{margin-left:8px;path{fill:", ";}}"], (props) => attachCustomStylesByClassNames(props), (props) => props.theme.fontFamily, (props) => props.theme.textColor || "#7C8184", (props) => props.theme.textColor || "#7C8184");
const StyledPaypalRedirectNoteWrapper = styled.div.withConfig({
  displayName: "PaypalPaymentMethodstyled__StyledPaypalRedirectNoteWrapper",
  componentId: "sc-15jz7ps-1"
})(["margin-left:-14px;margin-right:-14px;margin-top:16px;background-color:#f5f5f5;height:60px;display:flex;align-items:center;padding:0 14px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;", ";"], (props) => attachCustomStylesByClassNames(props));
const StyledPaypalRedirectNoteLabel = styled.p.withConfig({
  displayName: "PaypalPaymentMethodstyled__StyledPaypalRedirectNoteLabel",
  componentId: "sc-15jz7ps-2"
})(["font-family:", ";color:", ";font-size:14px;line-height:1.4;margin:0;", ";"], (props) => props.theme.fontFamily, (props) => props.theme.textColor || "#7C8184", (props) => attachCustomStylesByClassNames(props));
const TYPE = "Paypal";
const PaypalPaymentMethod = ({
  disabled,
  onSelect,
  activePaymentMethod,
  options,
  isIdTokenFetched
}) => {
  const {
    t
  } = useTranslation();
  const [oneClickEnabled, setOneClickEnabled] = useState(false);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PaymentMethod, { id: "payWithPaypal", ariaLabel: t("payment-methods.paypal.aria-label"), icon: /* @__PURE__ */ jsxRuntimeExports.jsx(PaypalIcon, {}), label: t("payment-methods.paypal.label"), disabled, onSelect, type: TYPE, activePaymentMethod, children: [
    (options == null ? void 0 : options.enableOneClick) && !isIdTokenFetched && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPaypalCheckboxWrapper, { className: "PaypalCheckboxContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(SaveCheckbox, { id: "paypal-one-click", value: oneClickEnabled, onChange: (e) => setOneClickEnabled(e.target.checked), disabled, label: t("payment-methods.paypal.one-click.label"), testId: "paypal-save-checkbox" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPaypalRedirectNoteWrapper, { className: "PaypalRedirectNoteContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPaypalRedirectNoteLabel, { className: "PaypalRedirectNoteContainer__Label", children: t("redirect-note.label") }) })
  ] });
};
const MAX_VISIBLE_TOTAL = 3;
const PaymentMethods = ({
  paymentMethods,
  respectPaymentMethodsOrder,
  disabled,
  onSelect,
  activePaymentMethod,
  children,
  isPaypalIdTokenFetched
}) => {
  const {
    t
  } = useTranslation();
  const [isShowMoreHidden, setIsShowMoreHidden] = useState(true);
  const handleSelect = (paymentMethod) => () => onSelect == null ? void 0 : onSelect(paymentMethod);
  const handleShowMore = () => setIsShowMoreHidden((prev) => !prev);
  const renderPaymentMethodItem = (pm) => {
    switch (pm.type) {
      case "card":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(PaymentMethod, { id: "payWithCard", ariaLabel: t("payment-methods.card.aria-label"), icon: /* @__PURE__ */ jsxRuntimeExports.jsx(CvcIcon, {}), label: t("payment-methods.card.label"), disabled, onSelect: handleSelect({
          type: "card"
        }), type: "Card", activePaymentMethod, children }, "card");
      case "apple_pay":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(ApplePayPaymentMethod, { disabled, onSelect: handleSelect(pm), activePaymentMethod }, pm.type);
      case "google_pay":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(GooglePayPaymentMethod, { disabled, onSelect: handleSelect(pm), activePaymentMethod }, pm.type);
      case "paypal":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(PaypalPaymentMethod, { disabled, onSelect: handleSelect(pm), activePaymentMethod, options: pm.options, isIdTokenFetched: isPaypalIdTokenFetched }, pm.type);
      default:
        return null;
    }
  };
  let baseList = [];
  let stickyHeadCount = 0;
  if (respectPaymentMethodsOrder) {
    baseList = paymentMethods ?? [];
  } else {
    const cardPM = paymentMethods.find((pm) => pm.type === "card") || null;
    const apms = (paymentMethods ?? []).filter((pm) => pm.type !== "card");
    baseList = cardPM ? [cardPM, ...apms] : apms;
    stickyHeadCount = cardPM ? 1 : 0;
  }
  const total = baseList.length;
  const showMoreButton = total > MAX_VISIBLE_TOTAL;
  let visibleList = baseList;
  if (showMoreButton && isShowMoreHidden) {
    const head = baseList.slice(0, stickyHeadCount);
    const tail = baseList.slice(stickyHeadCount);
    const collapsedTailCount = Math.max(0, MAX_VISIBLE_TOTAL - stickyHeadCount);
    const activeIndex = baseList.findIndex((a) => a.type === activePaymentMethod);
    const activeIndexInTail = activeIndex >= stickyHeadCount ? activeIndex - stickyHeadCount : -1;
    let slicedTail;
    if (activeIndexInTail >= collapsedTailCount && activeIndexInTail !== -1) {
      const activeItem = tail[activeIndexInTail];
      const withoutActive = tail.filter((_, i) => i !== activeIndexInTail);
      slicedTail = [activeItem, ...withoutActive].slice(0, collapsedTailCount);
    } else {
      slicedTail = tail.slice(0, collapsedTailCount);
    }
    visibleList = [...head, ...slicedTail];
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    visibleList.map(renderPaymentMethodItem),
    showMoreButton && /* @__PURE__ */ jsxRuntimeExports.jsx(ShowMoreOrLess, { showMore: isShowMoreHidden, onClick: handleShowMore })
  ] });
};
const CheckoutFormContext = createContext({});
const CheckoutFormContextProvider = CheckoutFormContext.Provider;
const useCheckoutFormContext = () => useContext(CheckoutFormContext);
const getFieldsErrors = (errors) => {
  const fieldErrors = Object.values(errors).filter(Boolean);
  return fieldErrors;
};
const useInputField = (params) => {
  const {
    value,
    onChange,
    formatter,
    validation: {
      validator,
      validationOrder,
      validationMessageByErrorType,
      isCardFormValidationTriggered
    } = {
      validator: () => ({}),
      validationOrder: [],
      validationMessageByErrorType: {},
      isCardFormValidationTriggered: false
    }
  } = params ?? {};
  const [isDirty, setIsDirty] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const {
    isValid,
    validate,
    validationResult,
    validationErrorType
  } = useValidator(validator, validationOrder);
  const previousValue = useRef("");
  const validationErrorMessage = getErrorMessage({
    isValid,
    validationErrorType,
    validationMessageByErrorType,
    isCardFormValidationTriggered
  });
  const getError = (inputValue) => {
    const {
      validationErrorType: updatedValidationErrorType,
      isValid: updatedIsValid
    } = validate(inputValue);
    return updatedValidationErrorType ? {
      type: updatedValidationErrorType,
      message: getErrorMessage({
        isValid: updatedIsValid,
        validationErrorType: updatedValidationErrorType,
        validationMessageByErrorType
      }) ?? ""
    } : void 0;
  };
  const handleChange = (event) => {
    if (event.currentTarget.value === value) {
      return;
    }
    let formattedValue;
    if (event.currentTarget.value.length < previousValue.current.length) {
      formattedValue = event.currentTarget.value;
    } else {
      formattedValue = formatter ? formatter(event.currentTarget.value, event.nativeEvent) : event.currentTarget.value;
    }
    setIsDirty(true);
    const error = getError(formattedValue);
    previousValue.current = formattedValue;
    onChange == null ? void 0 : onChange(formattedValue, error);
  };
  useEffect(() => {
    if (isCardFormValidationTriggered) {
      getError(value ?? "");
    }
  }, [isCardFormValidationTriggered, value]);
  const handleBlur = () => {
    setIsFocused(false);
  };
  const handleFocus = () => setIsFocused(true);
  const showErrorState = !!validationErrorMessage && !isValid;
  return {
    isDirty,
    isFocused,
    isValid,
    validationResult,
    validationErrorType,
    validationErrorMessage,
    handleChange,
    handleBlur,
    handleFocus,
    showErrorState
  };
};
const FieldContainer = styled.div.withConfig({
  displayName: "FieldContainerstyled__FieldContainer",
  componentId: "sc-1gzvwsu-0"
})(["display:flex;overflow-x:hidden;border:", ";border-bottom:", ";border-radius:", ";border-color:", ";transition:all 0.3s ease-out;position:relative;&:hover{border-color:", ";}&:has(input:disabled):hover{border-color:", ";}", ";"], (props) => props.theme.borderType !== "bottom" ? `1px solid ${props.theme.colors.border}` : void 0, (props) => props.theme.borderType === "bottom" ? `1px solid ${props.theme.colors.border}` : void 0, (props) => props.theme.borderRadius || (props.theme.borderType === "round" ? commonStyles.border.radius : "0"), (props) => {
  if (props.isFocused) {
    return props.theme.colors.borderFocused;
  }
  return props.isInvalid ? props.theme.colors.error : props.theme.colors.border;
}, (props) => props.isInvalid ? props.theme.colors.error : props.theme.colors.borderFocused, (props) => props.theme.colors.border, (props) => attachCustomStylesByClassNames(props));
const fieldStyles = css(["padding:0 ", ";outline:none;border:none;width:100%;font-size:", ";color:", ";background-color:", ";line-height:", ";"], commonStyles.inputs.paddingX, (props) => props.theme.fontSize.primary, (props) => props.theme.textColor, (props) => props.theme.backgroundColor, (props) => props.theme.lineHeight);
const TextField = styled.input.withConfig({
  displayName: "TextFieldstyled__TextField",
  componentId: "sc-13dixs2-0"
})(["", ";padding:0 ", ";", ";"], fieldStyles, commonStyles.inputs.paddingX, (props) => attachCustomStylesByClassNames(props));
styled.select.withConfig({
  displayName: "SelectFieldstyled__SelectField",
  componentId: "sc-kbeeyd-0"
})(["", " appearance:none;-webkit-appearance:none;-moz-appearance:none;background-color:", `;background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");background-repeat:no-repeat;background-position:right 0.75rem center;background-size:16px 12px;cursor:pointer;`, ";"], fieldStyles, (props) => props.theme.backgroundColor || commonStyles.inputs.background, (props) => attachCustomStylesByClassNames(props));
styled.option.withConfig({
  displayName: "SelectFieldstyled__SelectFieldOption",
  componentId: "sc-kbeeyd-1"
})(["", ";"], (props) => attachCustomStylesByClassNames(props));
const getBackgroundColor = (theme, checked) => {
  if (theme.backgroundColor) {
    return theme.backgroundColor;
  }
  return checked ? theme.colors.accent ?? commonStyles.inputs.background : commonStyles.inputs.background;
};
const CheckboxFieldBox = styled.span.withConfig({
  displayName: "CheckboxFieldstyled__CheckboxFieldBox",
  componentId: "sc-1s85043-0"
})(["display:inline-block;box-sizing:border-box;width:24px;height:24px;background-color:", ";border-radius:", ";transition:all 150ms;border:", ";margin-right:", ";transition:all 0.3s ease-out;", ";"], (props) => getBackgroundColor(props.theme, props.checked), (props) => props.theme.borderRadius || (props.theme.borderType === "round" ? commonStyles.border.radius : "0px"), (props) => `1px solid ${props.isFocused ? props.theme.colors.borderFocused : props.theme.colors.border}`, commonStyles.gutters.secondary, (props) => attachCustomStylesByClassNames(props));
styled.input.withConfig({
  displayName: "CheckboxFieldstyled__CheckboxInput",
  componentId: "sc-1s85043-1"
})(["position:absolute;appearance:none;-webkit-appearance:none;-moz-appearance:none;"]);
styled.span.withConfig({
  displayName: "CheckboxFieldstyled__CheckboxFieldIconContainer",
  componentId: "sc-1s85043-2"
})(["fill:none;stroke:", ";stoke-width:2px;display:", ";", ";"], (props) => props.theme.textColor || props.theme.colors.accentContrast || props.theme.colors.primary, (props) => props.checked ? "block" : "none", (props) => attachCustomStylesByClassNames(props));
styled.label.withConfig({
  displayName: "CheckboxFieldstyled__CheckboxFieldContainer",
  componentId: "sc-1s85043-3"
})(["display:flex;align-items:center;color:", ";max-width:max-content;cursor:pointer;&:hover ", "{border:", ";}", ";"], (props) => props.theme.textColor || props.theme.colors.secondary, CheckboxFieldBox, (props) => `1px solid ${props.theme.colors.borderFocused}`, (props) => attachCustomStylesByClassNames(props));
const CardBillingName = ({
  value = "",
  disabled = false,
  onChange
}) => {
  const {
    t
  } = useTranslation();
  const {
    isCardFormValidationTriggered
  } = useCheckoutFormContext();
  const {
    isValid,
    isFocused,
    validationErrorMessage,
    handleChange,
    handleBlur,
    handleFocus,
    showErrorState
  } = useInputField({
    value,
    onChange,
    validation: {
      validator: cardBillingNameValidator,
      validationOrder: cardBillingNameValidationOrder,
      validationMessageByErrorType: cardBillingNameValidationMessageByErrorType,
      isCardFormValidationTriggered
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldContainer, { isInvalid: showErrorState && !isValid, isFocused, className: "FieldContainer FieldContainer__BillingName", children: /* @__PURE__ */ jsxRuntimeExports.jsx(TextField, { type: "text", id: "billingName", name: "billingName", autoComplete: "off", autoCorrect: "off", spellCheck: false, value, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, placeholder: t("card.billing-name.placeholder"), "aria-label": t("card.billing-name.aria-label"), "aria-invalid": !isValid, disabled, className: "TextField TextField__BillingName" }) }),
    validationErrorMessage && showErrorState && /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage, { children: t(validationErrorMessage) })
  ] });
};
const CardExpiry$1 = ({
  value = "",
  disabled = false,
  onChange
}) => {
  const {
    t
  } = useTranslation();
  const {
    isCardFormValidationTriggered
  } = useCheckoutFormContext();
  const {
    isValid,
    isFocused,
    validationErrorMessage,
    handleChange,
    handleBlur,
    handleFocus,
    showErrorState
  } = useInputField({
    value,
    onChange,
    formatter: formatCardExpiry,
    validation: {
      validator: cardExpiryValidator,
      validationOrder: cardExpiryValidationOrder,
      validationMessageByErrorType: cardExpiryValidationMessageByErrorType,
      isCardFormValidationTriggered
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldContainer, { isInvalid: showErrorState && !isValid, isFocused, className: "FieldContainer FieldContainer__CardExpiry", children: /* @__PURE__ */ jsxRuntimeExports.jsx(TextField, { type: "text", id: "cardExpiry", name: "cardExpiry", inputMode: "numeric", autoComplete: "off", autoCorrect: "off", spellCheck: false, value, maxLength: 5, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, placeholder: t("card.expiry.placeholder"), "aria-label": t("card.expiry.aria-label"), "aria-invalid": !isValid, disabled, className: "TextField TextField__CardExpiry" }) }),
    validationErrorMessage && showErrorState && /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage, { children: t(validationErrorMessage) })
  ] });
};
const CardCvc = ({
  value,
  cardBrand,
  disabled,
  onChange
}) => {
  const {
    t
  } = useTranslation();
  const {
    isCardFormValidationTriggered
  } = useCheckoutFormContext();
  const cardCvcValidator = useMemo(() => getCardCvcValidator(cardBrand ?? "OTHER"), [cardBrand]);
  const {
    isValid,
    isFocused,
    validationErrorMessage,
    handleChange,
    handleBlur,
    handleFocus,
    showErrorState
  } = useInputField({
    value,
    onChange,
    formatter: formatCardCvc,
    validation: {
      validator: cardCvcValidator,
      validationOrder: cardCvcValidationOrder,
      validationMessageByErrorType: cardCvcValidationMessageByErrorType,
      isCardFormValidationTriggered
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldContainer, { isInvalid: showErrorState && !isValid, isFocused, className: "FieldContainer FieldContainer__CardCvc", children: /* @__PURE__ */ jsxRuntimeExports.jsx(TextField, { type: "text", id: "cardCvc", name: "cardCvc", inputMode: "numeric", autoComplete: "off", autoCorrect: "off", spellCheck: false, value, minLength: cardCvcLengthRange.min, maxLength: cardCvcLengthRange.max, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, placeholder: t("card.cvc.placeholder"), "aria-label": t("card.cvc.aria-label"), "aria-invalid": !isValid, disabled, className: "TextField TextField__CardCvc" }) }),
    validationErrorMessage && showErrorState && /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage, { children: t(validationErrorMessage) })
  ] });
};
const IconBlock = styled.span.withConfig({
  displayName: "CardNumberstyled__IconBlock",
  componentId: "sc-wwcizq-0"
})(["position:absolute;top:0;left:3px;justify-content:center;display:flex;height:100%;align-items:center;"]);
const IconContainer = styled.span.withConfig({
  displayName: "CardNumberstyled__IconContainer",
  componentId: "sc-wwcizq-1"
})(["padding:8px 6px;box-sizing:border-box;cursor:", ";pointer-events:", ";width:44px;height:40px;margin:0 1px;border-radius:4px;display:flex;align-items:center;justify-content:center;background-color:", ";opacity:", ";transition:all 0.25s ease-in;", ";&:hover{opacity:1;}"], ({
  isDisabled
}) => isDisabled ? "default" : "pointer", ({
  isDisabled
}) => isDisabled ? "none" : "all", ({
  isSelected,
  isDisabled,
  theme
}) => isSelected && !isDisabled ? theme.colors.border : "transparent", ({
  isSelected,
  isDisabled
}) => isSelected || isDisabled ? 1 : 0.25, (props) => attachCustomStylesByClassNames(props));
const CardInfoHeaderContainer = styled.div.withConfig({
  displayName: "CardNumberstyled__CardInfoHeaderContainer",
  componentId: "sc-wwcizq-2"
})(["width:100%;box-sizing:border-box;display:flex;align-items:center;justify-content:space-between;", ";"], (props) => attachCustomStylesByClassNames(props));
const CardInfoHeaderLabel = styled.p.withConfig({
  displayName: "CardNumberstyled__CardInfoHeaderLabel",
  componentId: "sc-wwcizq-3"
})(["font-weight:500;color:", ";", ";"], (props) => props.theme.textColor || props.theme.colors.secondary, (props) => attachCustomStylesByClassNames(props));
styled.div.withConfig({
  displayName: "CardNumberstyled__SavedCardsContainer",
  componentId: "sc-wwcizq-4"
})(["display:flex;align-items:center;width:150px;min-width:150px;justify-content:flex-end;background-color:", ";position:absolute;right:15px;top:50%;transform:translateY(-50%);", ";"], (props) => props.theme.backgroundColor, (props) => attachCustomStylesByClassNames(props));
styled.button.withConfig({
  displayName: "CardNumberstyled__ClearButton",
  componentId: "sc-wwcizq-5"
})(["", ";white-space:nowrap;display:flex;align-items:center;margin-right:", ";font-weight:", ";color:", ";", ";"], textButtonStyles, commonStyles.gutters.secondary, commonStyles.fontWeight.bold, (props) => props.theme.textColor || props.theme.colors.accent || props.theme.colors.primary, (props) => attachCustomStylesByClassNames(props));
const CardNumberContainer = styled.div.withConfig({
  displayName: "CardNumberstyled__CardNumberContainer",
  componentId: "sc-wwcizq-6"
})(["position:relative;", ";"], (props) => attachCustomStylesByClassNames(props));
const CardNumberTextField = styled(TextField).withConfig({
  displayName: "CardNumberstyled__CardNumberTextField",
  componentId: "sc-wwcizq-7"
})(["padding-left:", ";", ";"], (props) => props.hasSingleCardBrand ? "55px" : "105px", (props) => attachCustomStylesByClassNames(props));
const CardNumber$1 = ({
  value,
  cardBrand,
  preferredNetwork,
  disabled,
  selectedCardBrand,
  onChange,
  onPreferredCardNetworkChange
}) => {
  const {
    t
  } = useTranslation();
  const {
    cardOptions,
    isCardFormValidationTriggered,
    cardMetadata
  } = useCheckoutFormContext();
  const {
    isFocused,
    isValid,
    handleChange,
    handleBlur,
    handleFocus,
    showErrorState,
    validationErrorMessage
  } = useInputField({
    value,
    onChange,
    formatter: formatCardNumber,
    validation: {
      validator: cardNumberValidator,
      validationOrder: cardNumberValidationOrder,
      validationMessageByErrorType: cardNumberValidationMessageByErrorType,
      isCardFormValidationTriggered
    }
  });
  const showSupportedCardBrands = cardBrand === "OTHER" && (cardOptions == null ? void 0 : cardOptions.supportedCardBrands) && (cardOptions == null ? void 0 : cardOptions.supportedCardBrands.length) > 0;
  const getCardBrandsToShow = () => {
    if (selectedCardBrand) {
      return [selectedCardBrand];
    }
    if (cardMetadata && trimSpaces(value).length >= 8) {
      return cardMetadata.BinData.map((item) => item.Brand);
    }
    if (cardBrand) {
      return [cardBrand];
    }
    return ["OTHER"];
  };
  const cardBrandsToShow = getCardBrandsToShow();
  useEffect(() => {
    const hasCbItem = cardMetadata == null ? void 0 : cardMetadata.BinData.find((bin) => bin.Brand === "CB");
    const hasSelectedNetwork = Boolean(preferredNetwork);
    if (hasCbItem && !hasSelectedNetwork) {
      onPreferredCardNetworkChange == null ? void 0 : onPreferredCardNetworkChange("CB");
    }
  }, [cardMetadata, preferredNetwork]);
  const hasSingleCardBrand = cardBrandsToShow.length < 2;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(CardInfoHeaderContainer, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CardInfoHeaderLabel, { children: t("card-information.header.label") }),
      showSupportedCardBrands && /* @__PURE__ */ jsxRuntimeExports.jsx(SupportedCardBrand, { supportedCardBrands: cardOptions == null ? void 0 : cardOptions.supportedCardBrands })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CardNumberContainer, { className: "CardNumberContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FieldContainer, { isInvalid: !isValid && showErrorState, isFocused, className: "FieldContainer FieldContainer__CardNumber", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CardNumberTextField, { type: "text", id: "cardNumber", name: "cardNumber", inputMode: "numeric", autoComplete: "off", autoCorrect: "off", spellCheck: false, value, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, placeholder: t("card.number.placeholder"), "aria-label": t("card.number.aria-label"), "aria-invalid": !isValid, disabled, hasSingleCardBrand, className: "TextField TextField__CardNumber" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(IconBlock, { children: cardBrandsToShow.map((item) => /* @__PURE__ */ jsxRuntimeExports.jsx(IconContainer, { isDisabled: cardBrandsToShow.length < 2, isSelected: item === preferredNetwork, className: "CardNumberIconContainer", onClick: () => onPreferredCardNetworkChange == null ? void 0 : onPreferredCardNetworkChange(item), children: /* @__PURE__ */ jsxRuntimeExports.jsx(CardIcon, { brand: item }) }, item)) })
    ] }) }),
    showErrorState && validationErrorMessage && /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage, { children: t(validationErrorMessage) })
  ] });
};
const checkIsCardFormComplete = (card, cardErrors) => {
  const hasErrors = Object.values(cardErrors).some((error) => !!error);
  if (hasErrors) {
    return false;
  }
  const requiredFields = ["cardNumber", "billingName", "cardExpiry", "cardCvc"];
  return !requiredFields.some((field) => !(card == null ? void 0 : card[field]));
};
const ContentContainer = styled.div.withConfig({
  displayName: "CardSelectorstyled__ContentContainer",
  componentId: "sc-v4pa1v-0"
})(["position:relative;", ";"], (props) => attachCustomStylesByClassNames(props));
const DropdownTrigger = styled.button.withConfig({
  displayName: "CardSelectorstyled__DropdownTrigger",
  componentId: "sc-v4pa1v-1"
})(["position:absolute;top:66px;right:15px;", " white-space:nowrap;display:flex;align-items:center;font-weight:", ";color:", ";", ";"], textButtonStyles, commonStyles.fontWeight.bold, (props) => props.theme.textColor || props.theme.colors.accent || props.theme.colors.primary, (props) => attachCustomStylesByClassNames(props));
const DropdownContent = styled.ul.withConfig({
  displayName: "CardSelectorstyled__DropdownContent",
  componentId: "sc-v4pa1v-2"
})(["position:absolute;top:100%;left:0;margin-top:3px;box-sizing:border-box;width:100%;list-style:none;background-color:", ";z-index:1000;border:", ";padding:", ";display:block;border-radius:", ";overflow-y:auto;max-height:calc(100vh - 160px);", ";"], (props) => props.theme.backgroundColor || commonStyles.inputs.background, (props) => `1px solid ${props.theme.colors.border}`, commonStyles.gutters.secondary, (props) => props.theme.borderRadius || (props.theme.borderType === "round" ? commonStyles.border.radius : 0), (props) => attachCustomStylesByClassNames(props));
const TrashBinIconWrapper = styled.div.withConfig({
  displayName: "CardSelectorstyled__TrashBinIconWrapper",
  componentId: "sc-v4pa1v-3"
})(["opacity:0;margin-left:16px;"]);
const DropdownItem = styled.li.withConfig({
  displayName: "CardSelectorstyled__DropdownItem",
  componentId: "sc-v4pa1v-4"
})(["display:flex;align-items:center;justify-content:space-between;height:40px;cursor:pointer;&:hover{background-color:#f4f3f5;}border-radius:4px;color:", ";&:hover ", "{opacity:1;}"], (props) => props.theme.textColor || props.theme.colors.secondary, TrashBinIconWrapper);
const DropdownItemButton = styled.button.withConfig({
  displayName: "CardSelectorstyled__DropdownItemButton",
  componentId: "sc-v4pa1v-5"
})(["", " display:flex;align-items:center;width:100%;font-size:", ";color:#575757;", ";"], textButtonStyles, (props) => props.theme.fontSize.primary, (props) => attachCustomStylesByClassNames(props));
const CardBrandIcon = styled.span.withConfig({
  displayName: "CardSelectorstyled__CardBrandIcon",
  componentId: "sc-v4pa1v-6"
})(["", ";"], (props) => attachCustomStylesByClassNames(props));
const CloseIconWrapper = styled.div.withConfig({
  displayName: "CardSelectorstyled__CloseIconWrapper",
  componentId: "sc-v4pa1v-7"
})(["position:absolute;bottom:4px;right:15px;cursor:pointer;padding:8px;background-color:transparent;&:active{transform:scale(0.95);}"]);
const CardNumber = styled.div.withConfig({
  displayName: "CardSelectorstyled__CardNumber",
  componentId: "sc-v4pa1v-8"
})(["flex:1;text-align:left;padding-left:", ";", ";"], commonStyles.gutters.primary, (props) => attachCustomStylesByClassNames(props));
const CardExpiry = styled.div.withConfig({
  displayName: "CardSelectorstyled__CardExpiry",
  componentId: "sc-v4pa1v-9"
})(["margin-right:10px;", ";"], (props) => attachCustomStylesByClassNames(props));
styled.div.withConfig({
  displayName: "CardSelectorstyled__LoadingOverlay",
  componentId: "sc-v4pa1v-10"
})(["position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(255,255,255,0.8);display:flex;justify-content:center;align-items:center;z-index:10;"]);
styled.div.withConfig({
  displayName: "CardSelectorstyled__LoadingSpinner",
  componentId: "sc-v4pa1v-11"
})(["border:4px solid rgba(0,0,0,0.2);border-top:4px solid ", ";border-radius:50%;width:24px;height:24px;animation:spin 1s linear infinite;@keyframes spin{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}"], (props) => props.theme.colors.primary || "#007bff");
const DeactivateConfirmation = styled.div.withConfig({
  displayName: "CardSelectorstyled__DeactivateConfirmation",
  componentId: "sc-v4pa1v-12"
})(["position:absolute;top:100%;left:0px;z-index:1;box-sizing:border-box;width:100%;height:88px;background-color:rgb(255,255,255);margin-top:3px;height:88px;border-radius:4px;color:rgb(84,90,97);border:1px solid rgb(230,233,236);font-size:", ";"], (props) => props.theme.fontSize.primary);
const DeactivateCard = styled.div.withConfig({
  displayName: "CardSelectorstyled__DeactivateCard",
  componentId: "sc-v4pa1v-13"
})(["box-sizing:border-box;display:flex;justify-content:space-between;margin:2px;margin-bottom:8px;border-radius:4px;align-items:center;height:36px;background-color:#f4f3f5;padding:4px;padding-left:8px;"]);
const Divider = styled.div.withConfig({
  displayName: "CardSelectorstyled__Divider",
  componentId: "sc-v4pa1v-14"
})(["border-top:1px solid #eae7eb;width:100%;"]);
const DeactivateOptions = styled.div.withConfig({
  displayName: "CardSelectorstyled__DeactivateOptions",
  componentId: "sc-v4pa1v-15"
})(["height:40px;display:flex;justify-content:space-between;align-items:center;padding:0 8px;p{margin:0;}.loader-wrapper{display:flex;p{margin-left:8px;}}.buttons{display:flex;gap:8px;}"]);
const DeactivationErrorContainer = styled.div.withConfig({
  displayName: "CardSelectorstyled__DeactivationErrorContainer",
  componentId: "sc-v4pa1v-16"
})(["height:40px;display:flex;align-items:center;color:#993939;font-size:14px;& > svg{margin-right:8px;}"]);
const Button = styled.button.withConfig({
  displayName: "CardSelectorstyled__Button",
  componentId: "sc-v4pa1v-17"
})(["padding:8px 16px;font-size:14px;border:1px solid #d5cfd7;border-radius:4px;background:#fff;cursor:pointer;transition:color 0.3s ease,border-color 0.3s ease;&:hover{background-color:#f9f9f9;}&:focus{outline:none;box-shadow:0 0 3px rgba(0,0,0,0.2);}&:disabled{color:#c4c4c4;cursor:not-allowed;border-color:#e2e2e2;}"]);
const DeleteButton = styled(Button).withConfig({
  displayName: "CardSelectorstyled__DeleteButton",
  componentId: "sc-v4pa1v-18"
})(["color:#993939;&:disabled{color:#d8a1a1;}"]);
const useOutsideClick = ({
  ref,
  isActive,
  onOutsideClick
}) => {
  useLayoutEffect(() => {
    const handleDocumentClick = (event) => {
      if (!ref.current || !isActive) {
        return;
      }
      const targetElement = event.target;
      const isClickedOutside = !ref.current.contains(targetElement);
      if (isClickedOutside) {
        onOutsideClick();
      }
    };
    document.addEventListener("click", handleDocumentClick);
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [isActive, onOutsideClick, ref]);
};
const useDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsOpen((prev) => !prev);
  }, []);
  return {
    isOpen,
    toggleDropdown,
    setIsOpen
  };
};
const rotate = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
const SpinnerWrapper = styled.div.withConfig({
  displayName: "CardDeactivationLoader__SpinnerWrapper",
  componentId: "sc-cqoksy-0"
})(["display:inline-block;width:18px;height:18px;animation:", " 1s linear infinite;"], rotate);
const StyledSVG = styled.svg.withConfig({
  displayName: "CardDeactivationLoader__StyledSVG",
  componentId: "sc-cqoksy-1"
})(["width:100%;height:100%;fill:none;"]);
const CardDeactivationLoader = () => /* @__PURE__ */ jsxRuntimeExports.jsx(SpinnerWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSVG, { viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_2714_12311)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 0.75C9.41421 0.75 9.75 1.08579 9.75 1.5V4.5C9.75 4.91421 9.41421 5.25 9 5.25C8.58579 5.25 8.25 4.91421 8.25 4.5V1.5C8.25 1.08579 8.58579 0.75 9 0.75Z", fill: "#09030B" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 12.75C9.41421 12.75 9.75 13.0858 9.75 13.5V16.5C9.75 16.9142 9.41421 17.25 9 17.25C8.58579 17.25 8.25 16.9142 8.25 16.5V13.5C8.25 13.0858 8.58579 12.75 9 12.75Z", fill: "#09030B" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.16498 3.16889C3.45788 2.876 3.93275 2.876 4.22564 3.16889L6.34814 5.29139C6.64104 5.58428 6.64104 6.05916 6.34814 6.35205C6.05525 6.64494 5.58038 6.64494 5.28748 6.35205L3.16498 4.22955C2.87209 3.93666 2.87209 3.46178 3.16498 3.16889Z", fill: "#09030B" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.6494 11.6494C11.9423 11.3565 12.4171 11.3565 12.71 11.6494L14.8325 13.7719C15.1254 14.0648 15.1254 14.5396 14.8325 14.8325C14.5396 15.1254 14.0648 15.1254 13.7719 14.8325L11.6494 12.71C11.3565 12.4171 11.3565 11.9423 11.6494 11.6494Z", fill: "#09030B" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.75 9C0.75 8.58579 1.08579 8.25 1.5 8.25H4.5C4.91421 8.25 5.25 8.58579 5.25 9C5.25 9.41421 4.91421 9.75 4.5 9.75H1.5C1.08579 9.75 0.75 9.41421 0.75 9Z", fill: "#09030B" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.75 9C12.75 8.58579 13.0858 8.25 13.5 8.25H16.5C16.9142 8.25 17.25 8.58579 17.25 9C17.25 9.41421 16.9142 9.75 16.5 9.75H13.5C13.0858 9.75 12.75 9.41421 12.75 9Z", fill: "#09030B" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.34814 11.6494C6.64104 11.9423 6.64104 12.4171 6.34814 12.71L4.22564 14.8325C3.93275 15.1254 3.45788 15.1254 3.16498 14.8325C2.87209 14.5396 2.87209 14.0647 3.16498 13.7719L5.28748 11.6494C5.58038 11.3565 6.05525 11.3565 6.34814 11.6494Z", fill: "#09030B" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.8325 3.16889C15.1254 3.46178 15.1254 3.93666 14.8325 4.22955L12.71 6.35205C12.4171 6.64494 11.9423 6.64494 11.6494 6.35205C11.3565 6.05916 11.3565 5.58428 11.6494 5.29139L13.7719 3.16889C14.0647 2.876 14.5396 2.876 14.8325 3.16889Z", fill: "#09030B" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_2714_12311", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "18", height: "18", fill: "white" }) }) })
] }) });
const Wrapper = styled.span.withConfig({
  displayName: "card-alias-formatter__Wrapper",
  componentId: "sc-hl6u0v-0"
})(["font-family:inter;display:inline-flex;align-items:center;letter-spacing:1px;"]);
const Masked = styled.span.withConfig({
  displayName: "card-alias-formatter__Masked",
  componentId: "sc-hl6u0v-1"
})(["height:12px;display:inline-block;color:#b3b3b3;margin-right:8px;"]);
const Digits = styled.span.withConfig({
  displayName: "card-alias-formatter__Digits",
  componentId: "sc-hl6u0v-2"
})(["color:#575757;"]);
const CardAliasFormatter = ({
  alias = ""
}) => {
  const lastFour = alias.slice(-4).padStart(4, "*");
  const maskedPart = "**** **** **** ";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Wrapper, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Masked, { children: maskedPart }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Digits, { children: lastFour.slice(-4) })
  ] });
};
const CardSelector = ({
  disabled = false,
  cardIsSelected,
  onSelect,
  children
}) => {
  const {
    t
  } = useTranslation();
  const {
    deactivatingCardError,
    setDeactivatingCardError,
    savedCards,
    onDeactivateSavedCard,
    deactivatingSavedCard,
    deactivatingCardResult
  } = useCheckoutFormContext();
  const {
    isOpen,
    toggleDropdown,
    setIsOpen: setIsDropdownOpen
  } = useDropdown();
  const [cardToDeactivate, setCardToDeactivate] = useState(null);
  const [localSavedCards, setLocalSavedCards] = useState(savedCards);
  const dropdownRef = useRef(null);
  const deactivateConfirmationRef = useRef(null);
  useOutsideClick({
    ref: deactivateConfirmationRef,
    isActive: !!cardToDeactivate,
    onOutsideClick: () => {
      setCardToDeactivate(null);
      setDeactivatingCardError == null ? void 0 : setDeactivatingCardError(false);
    }
  });
  useEffect(() => {
    if (!(deactivatingCardResult == null ? void 0 : deactivatingCardResult.Id)) return;
    setLocalSavedCards((prev) => {
      if (!(prev == null ? void 0 : prev.length)) return prev;
      const newCards = prev.filter((card) => card.Id !== deactivatingCardResult.Id);
      if (newCards.length === prev.length) {
        return prev;
      }
      return newCards;
    });
    setCardToDeactivate(null);
    setIsDropdownOpen(true);
  }, [deactivatingCardResult, setIsDropdownOpen]);
  useHandleDropdownClick({
    dropdownContentRef: dropdownRef,
    isOpen,
    setIsOpen: (state) => {
      setIsDropdownOpen(state);
      if (!state) {
        setCardToDeactivate(null);
      }
    }
  });
  const handleCardSelect = (card) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDropdownOpen(false);
    setCardToDeactivate(null);
    onSelect == null ? void 0 : onSelect(card);
  };
  const handleClearSavedCard = () => {
    onSelect == null ? void 0 : onSelect(null);
  };
  const handleDeactivateCard = (event, cardId) => {
    event.stopPropagation();
    onDeactivateSavedCard == null ? void 0 : onDeactivateSavedCard(cardId);
  };
  const handleToggleDropdown = (e) => {
    if (deactivatingCardError) {
      setDeactivatingCardError == null ? void 0 : setDeactivatingCardError(false);
    }
    if (cardToDeactivate) {
      setCardToDeactivate(null);
    }
    toggleDropdown(e);
  };
  const handleTrashIconClick = (e, card) => {
    e.stopPropagation();
    setCardToDeactivate(card);
    toggleDropdown(e);
  };
  const handleCancelDeactivating = () => {
    setCardToDeactivate(null);
    setDeactivatingCardError == null ? void 0 : setDeactivatingCardError(false);
  };
  if (!Array.isArray(localSavedCards) || localSavedCards.length === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children });
  }
  const dropdownToggle = cardIsSelected ? /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIconWrapper, { onClick: handleClearSavedCard, "aria-label": t("card.saved-cards.remove-selected"), children: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, {}) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(DropdownTrigger, { id: "selectSavedCard", "aria-haspopup": "listbox", "aria-expanded": isOpen, onClick: handleToggleDropdown, disabled, children: t("card.saved-cards.choose-card.label") });
  const savedCardsDropdown = isOpen ? /* @__PURE__ */ jsxRuntimeExports.jsx(DropdownContent, { ref: dropdownRef, role: "listbox", "aria-labelledby": "selectSavedCard", children: localSavedCards.map((card) => /* @__PURE__ */ jsxRuntimeExports.jsx(DropdownItem, { role: "option", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(DropdownItemButton, { onClick: handleCardSelect(card), "aria-label": t("card.saved-cards.aria-label", {
    ending: getCardNumberEnding(card.Alias)
  }), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(CardBrandIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CardIcon, { brand: card.CardProvider ?? "OTHER" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CardNumber, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CardAliasFormatter, { alias: card.Alias }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CardExpiry, { children: convertCardExpiryToString(card.ExpirationDate) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TrashBinIconWrapper, { "data-testid": "trash-bin-icon", onClick: (e) => handleTrashIconClick(e, card), children: /* @__PURE__ */ jsxRuntimeExports.jsx(TrashBinIcon, {}) })
  ] }) }, card.Id)) }) : null;
  let deactivateInnerContent = null;
  if (deactivatingSavedCard) {
    deactivateInnerContent = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "loader-wrapper", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CardDeactivationLoader, {}),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: t("card.saved-cards.delete-loading.label") })
    ] });
  } else {
    deactivateInnerContent = /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: t("card.saved-cards.delete-confirm.label") });
  }
  const cardToDeactivateConfirmation = cardToDeactivate ? /* @__PURE__ */ jsxRuntimeExports.jsxs(DeactivateConfirmation, { ref: deactivateConfirmationRef, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DeactivateCard, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CardBrandIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CardIcon, { brand: cardToDeactivate.CardProvider ?? "OTHER" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CardNumber, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CardAliasFormatter, { alias: cardToDeactivate.Alias }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CardExpiry, { children: convertCardExpiryToString(cardToDeactivate.ExpirationDate) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TrashBinIconWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TrashBinIcon, {}) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(DeactivateOptions, { children: deactivatingCardError ? /* @__PURE__ */ jsxRuntimeExports.jsxs(DeactivationErrorContainer, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: t("card.saved-cards.delete-error.label") })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      deactivateInnerContent,
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "buttons", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { disabled: deactivatingSavedCard, onClick: handleCancelDeactivating, children: t("card.saved-cards.cancel.label") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeleteButton, { disabled: deactivatingSavedCard, onClick: (e) => handleDeactivateCard(e, cardToDeactivate.Id), children: t("card.saved-cards.delete.label") })
      ] })
    ] }) })
  ] }) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ContentContainer, { children: [
    children,
    dropdownToggle,
    savedCardsDropdown,
    cardToDeactivateConfirmation
  ] });
};
const CheckoutLegalNoticeContainer = styled.div.withConfig({
  displayName: "CheckoutLegalNoticestyled__CheckoutLegalNoticeContainer",
  componentId: "sc-166s3bl-0"
})(["display:flex;align-items:center;margin:0 0 14px 2px;"]);
const NoticeContainer = styled.div.withConfig({
  displayName: "CheckoutLegalNoticestyled__NoticeContainer",
  componentId: "sc-166s3bl-1"
})(["font-size:16px;color:#575757;line-height:20px;font-weight:500;.privacy{color:#575757;text-decoration:none;border-bottom:1px solid #575757;cursor:pointer;}"]);
const CheckoutLegalNotice = () => {
  const {
    t
  } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CheckoutLegalNoticeContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(NoticeContainer, { children: [
    t("card.psp.legal.notice"),
    " - ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: "privacy", href: "https://mangopay.com/privacy-statement", target: "_blank", rel: "noreferrer", children: t("card.psp.legal.privacy") })
  ] }) });
};
const formatCardAlias = (alias) => {
  if (!alias) return "";
  const masked = "*".repeat(alias.length - 4) + alias.slice(-4);
  return masked.replace(/(.{4})/g, "$1 ").trim();
};
const CardForm = ({
  onChange,
  disabled,
  onSelectCard,
  selectedCard,
  clearForm
}) => {
  const {
    t
  } = useTranslation();
  const {
    cardFieldsSet,
    enableSaveCard
  } = useCheckoutFormContext();
  const card = cardFieldsSet.value;
  const [cardErrors, setCardErrors] = useState({
    cardNumber: void 0,
    billingName: void 0,
    cardExpiry: void 0,
    cardCvc: void 0,
    preferredCardNetwork: void 0,
    saveCard: void 0
  });
  const cardBrand = (selectedCard == null ? void 0 : selectedCard.CardProvider) || getCardBrand((card == null ? void 0 : card.cardNumber) ?? "");
  const handleCardChange = (updatedCard, updatedErrors) => {
    setCardErrors(updatedErrors);
    const errors = getFieldsErrors(updatedErrors);
    const isComplete = checkIsCardFormComplete(updatedCard, updatedErrors);
    onChange == null ? void 0 : onChange({
      value: updatedCard,
      errors,
      isComplete
    });
  };
  const handleFieldChange = (fieldName) => (value, error) => {
    let updatedCard = {
      ...card
    };
    let updatedErrors = {
      ...cardErrors
    };
    if (fieldName === "cardNumber" && selectedCard) {
      updatedCard = {
        ...updatedCard,
        cardNumber: ""
      };
      clearForm == null ? void 0 : clearForm();
    } else {
      updatedCard = {
        ...updatedCard,
        [fieldName]: value
      };
    }
    updatedErrors = {
      ...updatedErrors,
      [fieldName]: error ? {
        ...error,
        field: fieldName
      } : void 0
    };
    handleCardChange(updatedCard, updatedErrors);
  };
  const handleEnableSaveCard = () => {
    handleFieldChange("saveCard")(!card.saveCard);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Column, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CardSelector, { cardIsSelected: !!selectedCard, onSelect: onSelectCard, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CardNumber$1, { value: selectedCard ? formatCardAlias(selectedCard.Alias) : (card == null ? void 0 : card.cardNumber) ?? "", preferredNetwork: card == null ? void 0 : card.preferredCardNetwork, cardBrand, selectedCardBrand: selectedCard == null ? void 0 : selectedCard.CardProvider, disabled, onChange: handleFieldChange("cardNumber"), onPreferredCardNetworkChange: handleFieldChange("preferredCardNetwork") }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Column, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CardBillingName, { value: selectedCard ? selectedCard.CardHolderName : (card == null ? void 0 : card.billingName) || "", disabled: disabled || !!selectedCard, onChange: handleFieldChange("billingName") }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Row, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Column, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CardExpiry$1, { value: selectedCard ? convertCardExpiryToString(selectedCard.ExpirationDate) : (card == null ? void 0 : card.cardExpiry) || "", disabled: disabled || !!selectedCard, onChange: handleFieldChange("cardExpiry") }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Column, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CardCvc, { value: selectedCard ? "***" : (card == null ? void 0 : card.cardCvc) || "", cardBrand, disabled: disabled || !!selectedCard, onChange: handleFieldChange("cardCvc") }) })
    ] }),
    enableSaveCard && /* @__PURE__ */ jsxRuntimeExports.jsx(SaveCheckboxWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SaveCheckbox, { value: !!card.saveCard, onChange: handleEnableSaveCard, disabled: disabled || !!selectedCard, label: t("card.save.label"), testId: "save-card-checkbox" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CheckoutLegalNotice, {})
  ] });
};
const initialState = {
  value: {},
  isComplete: false,
  errors: []
};
const CheckoutForm = forwardRef(({
  disabled,
  paymentMethods,
  respectPaymentMethodsOrder,
  onChange,
  onPaymentMethodSelect,
  onDeactivateSavedCard,
  loading,
  activePaymentMethod,
  cardMetadata,
  setIsCardFormComplete,
  isCardFormValidationTriggered,
  setIsCardFormValidationTriggered,
  deactivatingSavedCard,
  deactivatingCardResult,
  deactivatingCardError = false,
  setDeactivatingCardError,
  isPaypalIdTokenFetched
}, forwardedRef) => {
  var _a, _b;
  const {
    t
  } = useTranslation();
  const [cardFieldsSet, setCardFieldsSet] = useState(initialState);
  const [cardNumberValue, setCardNumberValue] = useState("");
  const [cardBillingNameValue, setCardBillingNameValue] = useState("");
  const [cardExpiryValue, setCardExpiryValue] = useState("");
  const [cardCvcValue, setCardCvcValue] = useState("");
  const [selectedCard, setSelectedCard] = useState(null);
  const isShowCardOnlyPM = (paymentMethods == null ? void 0 : paymentMethods.length) === 1 && ((_a = paymentMethods == null ? void 0 : paymentMethods[0]) == null ? void 0 : _a.type) === "card";
  const cardOptions = (_b = paymentMethods == null ? void 0 : paymentMethods.find((pm) => pm.type === "card")) == null ? void 0 : _b.options;
  const enableSaveCard = (cardOptions == null ? void 0 : cardOptions.enableSaveCard) ?? false;
  const savedCards = (cardOptions == null ? void 0 : cardOptions.savedCards) ?? [];
  const contextValues = useMemo(() => ({
    cardFieldsSet,
    cardMetadata,
    cardNumberValue,
    setCardNumberValue,
    cardBillingNameValue,
    setCardBillingNameValue,
    cardExpiryValue,
    setCardExpiryValue,
    cardCvcValue,
    setCardCvcValue,
    cardOptions,
    isCardFormValidationTriggered,
    enableSaveCard,
    deactivatingCardError,
    setDeactivatingCardError,
    savedCards,
    onDeactivateSavedCard,
    deactivatingSavedCard,
    deactivatingCardResult
  }), [cardFieldsSet, cardMetadata, cardNumberValue, setCardNumberValue, cardBillingNameValue, setCardBillingNameValue, cardExpiryValue, setCardExpiryValue, cardCvcValue, setCardCvcValue, cardOptions, isCardFormValidationTriggered, deactivatingCardError, setDeactivatingCardError, savedCards, onDeactivateSavedCard, deactivatingSavedCard, deactivatingCardResult]);
  const handleCardChange = (updatedCardFieldsSet) => {
    const errors = ((updatedCardFieldsSet == null ? void 0 : updatedCardFieldsSet.errors) ?? []).map((error) => ({
      ...error,
      message: t(error.ResultMessage ?? "Unknown error")
    }));
    const checkoutChange = {
      isComplete: updatedCardFieldsSet.isComplete || false,
      errors,
      value: {
        card: updatedCardFieldsSet.value
      }
    };
    setCardFieldsSet(updatedCardFieldsSet);
    setIsCardFormComplete(updatedCardFieldsSet.isComplete);
    onChange == null ? void 0 : onChange(checkoutChange);
  };
  const handlePaymentMethodSelect = (paymentMethod) => {
    if (loading || disabled) return;
    onPaymentMethodSelect == null ? void 0 : onPaymentMethodSelect(paymentMethod.type);
  };
  const clearForm = () => {
    setCardFieldsSet(initialState);
    setIsCardFormComplete(false);
    setIsCardFormValidationTriggered(false);
    setCardNumberValue("");
    setCardBillingNameValue("");
    setCardExpiryValue("");
    setCardCvcValue("");
    setSelectedCard(null);
  };
  const handleSavedCardSelect = (savedCard) => {
    clearForm();
    setSelectedCard(savedCard);
    if (savedCard) {
      setCardNumberValue(formatCardAlias(savedCard.Alias));
      setCardBillingNameValue(savedCard.CardHolderName);
      setCardExpiryValue(convertCardExpiryToString(savedCard.ExpirationDate));
      setCardCvcValue("***");
      onChange == null ? void 0 : onChange({
        value: {
          savedCard
        },
        errors: [],
        isComplete: true
      });
    } else {
      onChange == null ? void 0 : onChange({
        value: {},
        errors: [],
        isComplete: false
      });
    }
  };
  useImperativeHandle(forwardedRef, () => ({
    clearForm
  }));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CheckoutFormContextProvider, { value: contextValues, children: isShowCardOnlyPM ? /* @__PURE__ */ jsxRuntimeExports.jsx(CardForm, { onChange: handleCardChange, onSelectCard: handleSavedCardSelect, disabled, selectedCard, clearForm }) : /* @__PURE__ */ jsxRuntimeExports.jsx(PaymentMethods, { disabled, paymentMethods: paymentMethods ?? [], respectPaymentMethodsOrder, onSelect: handlePaymentMethodSelect, activePaymentMethod, isPaypalIdTokenFetched, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CardForm, { onChange: handleCardChange, onSelectCard: handleSavedCardSelect, disabled, selectedCard, clearForm }) }) });
});
const CardPaymentMethodButton = styled.button.withConfig({
  displayName: "PayButtonstyled__CardPaymentMethodButton",
  componentId: "sc-hdte0o-0"
})(["", ";display:flex;justify-content:center;align-items:center;width:100%;text-align:center;margin-top:", ";padding:", ";color:", ";font-size:", ";font-weight:", ";& svg{margin-right:8px;path{fill:", ";}}", ";"], buttonStyles, commonStyles.gutters.primary, commonStyles.gutters.primary, (props) => props.theme.textColor || props.theme.colors.primary, (props) => props.theme.fontSize.primary, commonStyles.fontWeight.semiBold, (props) => props.theme.textColor || props.theme.colors.primary, (props) => attachCustomStylesByClassNames(props));
const parseAmount = (amount) => (amount / 100).toFixed(2);
const CardPayButton = ({
  disabled,
  handlePay
}) => {
  var _a;
  const {
    t,
    i18n
  } = useTranslation();
  const {
    amount,
    currency
  } = useCheckoutContext();
  const parsedAmount = amount ? parseAmount(amount) : amount;
  const currencySymbol = ((_a = currencyCodeWithSymbols.find(({
    code
  }) => code === currency)) == null ? void 0 : _a.symbol) || currency;
  const parsedAmountFormatted = (parsedAmount == null ? void 0 : parsedAmount.toString().includes(".")) ? parsedAmount : `${parsedAmount || 0}.00`;
  const label = i18n.language === "custom" ? t("pay-button.label") : `${t("pay-button.label")} ${currencySymbol} ${parsedAmountFormatted}`;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(CardPaymentMethodButton, { id: "pay", type: "submit", disabled, onClick: handlePay, "aria-label": t("pay-button.aria-label"), className: "PayButton PayButton__Card", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(LockIcon, {}),
    label
  ] });
};
const ApplePayButtonContainer = styled.button.withConfig({
  displayName: "ApplePayPayButtonstyled__ApplePayButtonContainer",
  componentId: "sc-fqkfa5-0"
})(["", ";display:block;width:100%;margin-top:", ";padding:", ";transition:all 0.3s ease-out;", ";background-color:#000;border:none;& svg{height:20px;transform:translate(0,1px);padding:1px 0;}&:hover{background-color:rgba(0,0,0,0.8);}"], buttonStyles, commonStyles.gutters.primary, commonStyles.gutters.primary, (props) => attachCustomStylesByClassNames(props));
const ApplePayPayButton = ({
  disabled = false,
  handlePay = () => {
  }
}) => {
  const {
    t
  } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ApplePayButtonContainer, { id: "PayWithApplePay", type: "submit", disabled, onClick: handlePay, "aria-label": t("pay-button.aria-label"), className: "PayButton PayButton__ApplePay", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ApplePayPayButtonIcon, {}) });
};
const GooglePayButtonContainer = styled.div.withConfig({
  displayName: "GooglePayButtonstyled__GooglePayButtonContainer",
  componentId: "sc-1oak0n1-0"
})(["margin-top:14px;margin-bottom:14px;height:53px;", ";"], (props) => attachCustomStylesByClassNames(props));
const GooglePayButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(GooglePayButtonContainer, { as: "div", id: "google_button_container", className: "PaymentMethodButton PaymentMethodButton__GooglePay" });
const PaypalPayButtonContainer = styled.div.withConfig({
  displayName: "PaypalPayButtonstyled__PaypalPayButtonContainer",
  componentId: "sc-1bbcgg2-0"
})(["margin-top:14px;margin-bottom:14px;", ";"], (props) => attachCustomStylesByClassNames(props));
const PaypalPayButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(PaypalPayButtonContainer, { as: "div", id: "paypal-button-container", className: "PaymentMethodButton PaymentMethodButton__PayPal" });
const PAY_BUTTON_MAP = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  card: CardPayButton,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  google_pay: GooglePayButton,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  apple_pay: ApplePayPayButton,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  paypal: PaypalPayButton
};
const StyledSuccessStateWrapper = styled.div.withConfig({
  displayName: "SuccessStatestyled__StyledSuccessStateWrapper",
  componentId: "sc-1lsc0qg-0"
})(["display:block;width:100%;height:100%;background-color:", ";position:absolute;top:0;left:0;min-width:100px;min-height:200px;z-index:999;opacity:", ";visibility:", ";transition:all 0.3s ease-out;", ";"], (props) => props.theme.backgroundColor || "#fff", (props) => props.showSuccessState ? 1 : 0, (props) => props.showSuccessState ? "visible" : "hidden", (props) => attachCustomStylesByClassNames(props));
const StyledSuccessStateContent = styled.div.withConfig({
  displayName: "SuccessStatestyled__StyledSuccessStateContent",
  componentId: "sc-1lsc0qg-1"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);", ";"], (props) => attachCustomStylesByClassNames(props));
const StyledSuccessStateContentText = styled.p.withConfig({
  displayName: "SuccessStatestyled__StyledSuccessStateContentText",
  componentId: "sc-1lsc0qg-2"
})(["margin-top:24px;font-size:24px;font-weight:", ";font-family:", ";color:", ";text-align:center;@media screen and (max-width:400px){font-size:18px;}", ";"], commonStyles.fontWeight.bold, (props) => props.theme.fontFamily, (props) => props.theme.textColor, (props) => attachCustomStylesByClassNames(props));
const check = keyframes(["from{stroke-dashoffset:37.87860107421875px;}to{stroke-dashoffset:0;}"]);
const checkAnimation = css(["animation:", " 0.3s ease;animation-delay:0.21s;animation-fill-mode:backwards;"], check);
const StyledCheck = styled.div.withConfig({
  displayName: "SuccessStatestyled__StyledCheck",
  componentId: "sc-1lsc0qg-3"
})(["svg .check-path{stroke-dasharray:37.87860107421875px;", ";}"], checkAnimation);
const StyledSuccessStateContentIcon = styled(StyledCheck).withConfig({
  displayName: "SuccessStatestyled__StyledSuccessStateContentIcon",
  componentId: "sc-1lsc0qg-4"
})(["width:49px;height:49px;background-color:#1cce6a;margin:0 auto;border-radius:50%;display:flex;justify-content:center;align-items:center;margin-bottom:35px;svg{width:20px;path{stroke:#fff;stroke-width:3px;}}", ";"], (props) => attachCustomStylesByClassNames(props));
const SuccessState = ({
  showSuccessState = false
}) => {
  const {
    t
  } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSuccessStateWrapper, { showSuccessState, className: "SuccessStateContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSuccessStateContent, { className: "SuccessStateContainer__Content", children: [
    showSuccessState && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSuccessStateContentIcon, { className: "SuccessStateContainer__Content__Icon", children: /* @__PURE__ */ jsxRuntimeExports.jsx(SuccessCheckIcon, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSuccessStateContentText, { className: "SuccessStateContainer__Content__Label", children: t("payment-success-state.label") })
  ] }) });
};
const FailedStateKeyFrame = keyframes(["0%{opacity:0;transform:translateY(-24px);}100%{opacity:1;transform:1;}"]);
const FailedStateAnimation = css(["animation:", " 0.3s ease-out;animation-fill-mode:backwards;"], FailedStateKeyFrame);
const StyledFailedStateWrapper = styled.div.withConfig({
  displayName: "FailedStatestyled__StyledFailedStateWrapper",
  componentId: "sc-1hqytcw-0"
})(["width:100%;display:flex;justify-content:center;", ";"], (props) => attachCustomStylesByClassNames(props));
const StyledFailedStateLabel = styled.p.withConfig({
  displayName: "FailedStatestyled__StyledFailedStateLabel",
  componentId: "sc-1hqytcw-1"
})(["font-family:", ";color:", ";font-size:16px;", ";", ";"], (props) => props.theme.fontFamily, (props) => props.theme.colors.error, FailedStateAnimation, (props) => attachCustomStylesByClassNames(props));
const transformLabelToTranslationKey = (label) => typeof label === "string" ? `error.${label.toLowerCase()}` : label;
const FailedState = ({
  label,
  showFailedState = false
}) => {
  const {
    t
  } = useTranslation();
  const transformedLabel = transformLabelToTranslationKey(label || "unknown");
  const errorMessage = label && translationKeys.includes(transformedLabel) ? t(transformedLabel) : t(label);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFailedStateWrapper, { className: "PaymentErrorContainer", children: showFailedState && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFailedStateLabel, { className: "PaymentErrorContainer__Label", children: errorMessage }) });
};
export {
  AmountOptions,
  ApplePayPayButton,
  ButtonLoadingOverlay,
  D as ButtonLoadingOverlayWrapper,
  CardPayButton,
  CheckoutContainer,
  CheckoutForm,
  CheckoutSdkEnvironment,
  CheckoutSdkType,
  CurrencyCode,
  FailedState,
  FullScreenLoader,
  GooglePayButton,
  LoadingState,
  PAY_BUTTON_MAP,
  PreloadingComponent,
  SdkOptions,
  SuccessState,
  commonStyles,
  currencyCodeWithSymbols,
  defaultTheme,
  i18nResources,
  A as initI18n,
  translationKeys
};
//# sourceMappingURL=index.js.map
